import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export enum AccountType {
  BILLING_SPECIALIST = 'BILLING_SPECIALIST',
  CARE_COORDINATOR = 'CARE_COORDINATOR',
  CHILD = 'CHILD',
  PARENT = 'PARENT',
  PARENT_COACH = 'PARENT_COACH',
  SERVICE = 'SERVICE',
  STANDALONE_CLIENT = 'STANDALONE_CLIENT',
  SUPPORT = 'SUPPORT',
  THERAPIST = 'THERAPIST'
}

export type AchievementProgress = {
  achievedCount?: Maybe<Scalars['Int']['output']>;
  achievedPoints?: Maybe<Scalars['Int']['output']>;
  possibleCount?: Maybe<Scalars['Int']['output']>;
  possiblePoints?: Maybe<Scalars['Int']['output']>;
};

export type AchievementQueryOptions = {
  excludePending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityItem = {
  date: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AddConnectionResponse = {
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
};

export type Address = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Appointment = {
  appointmentType: AppointmentType;
  attendees: Array<Maybe<User>>;
  contactMethod: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  length: Scalars['Int']['output'];
  permissions?: Maybe<Array<Maybe<AppointmentPermission>>>;
  pmStatus?: Maybe<Scalars['String']['output']>;
  pricingInfo: PricingInfo;
  recurrence?: Maybe<AppointmentRecurrence>;
  requestedPaymentId?: Maybe<Scalars['String']['output']>;
  telehealthJoinUrl?: Maybe<Scalars['String']['output']>;
};

export enum AppointmentPermission {
  CANCEL = 'CANCEL',
  RESCHEDULE = 'RESCHEDULE'
}

export type AppointmentRecurrence = {
  id?: Maybe<Scalars['String']['output']>;
  recurringCount?: Maybe<Scalars['Int']['output']>;
  recurringInterval?: Maybe<RecurringAppointmentInterval>;
};

export type AppointmentType = {
  applicableCareTeamMemberIds: Array<Maybe<Scalars['Int']['output']>>;
  applicableCareTeamMembers: Array<User>;
  contactMethods: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isGroup: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pricingInfo?: Maybe<PricingInfo>;
};

export type Assessment = {
  categoryCriteria?: Maybe<Array<Maybe<CategoryCriteria>>>;
  finePrint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  parameters?: Maybe<AssessmentParameters>;
  questions: Array<Maybe<AssessmentQuestion>>;
  subAssessments?: Maybe<Array<Maybe<Assessment>>>;
  type: Scalars['String']['output'];
};

export type AssessmentAnswer = {
  choiceId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
  responseText?: InputMaybe<Scalars['String']['input']>;
};

export type AssessmentAssignment = {
  assessmentIdentifier: Scalars['String']['output'];
  assessmentParameters?: Maybe<AssessmentParameters>;
  assigneeId: Scalars['Int']['output'];
};

export type AssessmentAssignmentRequest = {
  assessmentIdentifier: Scalars['String']['input'];
  assessmentParameters?: InputMaybe<AssessmentParametersInput>;
  assigneeId: Scalars['Int']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssessmentChoice = {
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type AssessmentCompletion = {
  answers: Array<InputMaybe<AssessmentAnswer>>;
  assessmentIdentifier: Scalars['String']['input'];
  assessmentParameters?: InputMaybe<AssessmentParametersInput>;
};

export type AssessmentParameters = {
  subjectUserId?: Maybe<Scalars['Int']['output']>;
};

export type AssessmentParametersInput = {
  subjectUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentQueryOptions = {
  assessmentIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onDemand?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssessmentQuestion = {
  choices?: Maybe<Array<Maybe<AssessmentChoice>>>;
  id: Scalars['Int']['output'];
  precursorText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type?: Maybe<AssessmentType>;
};

export enum AssessmentType {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  MULTIPLE_SELECTION = 'MULTIPLE_SELECTION',
  NUMBER_SCALE = 'NUMBER_SCALE',
  TEXT = 'TEXT'
}

export type AvailableDay = {
  date: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type AvailableDaysQueryResponse = {
  availableDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AvailableTimeSlot = {
  startTime: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type BillingItem = {
  amountPaid?: Maybe<Scalars['String']['output']>;
  appointmentId?: Maybe<Scalars['String']['output']>;
  cardSource?: Maybe<Scalars['String']['output']>;
  client?: Maybe<User>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offeringId?: Maybe<Scalars['String']['output']>;
  originalPrice?: Maybe<Scalars['String']['output']>;
  paymentMedium?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<User>;
  receiptLastSentAt?: Maybe<Scalars['String']['output']>;
  requestedPaymentId?: Maybe<Scalars['String']['output']>;
  shownDescription?: Maybe<Scalars['String']['output']>;
  shownNote?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripeError?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CanReceiveMessages = {
  canReceiveMessages: Scalars['Boolean']['output'];
  therapistId: Scalars['Int']['output'];
};

export type CareScreener = {
  consultStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  directIntakeStatus?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  schedulingQueryStartDate?: Maybe<Scalars['String']['output']>;
  typeformId: Scalars['String']['output'];
  typeformResponseId: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CareTeam = {
  careCoordinationEnabled: Scalars['Boolean']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type CareTeamMemberMatch = {
  careTeamMember: User;
  user: User;
};

export type CategoryCriteria = {
  category: Scalars['String']['output'];
  clinicalCategory?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  maxScore: Scalars['Int']['output'];
  minScore: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
};

export type ChildParentRelationship = {
  adultId?: Maybe<Scalars['Int']['output']>;
  childId?: Maybe<Scalars['Int']['output']>;
};

export type ChildProgressReport = {
  journalEntries?: Maybe<Scalars['Int']['output']>;
  moodChats?: Maybe<Scalars['Int']['output']>;
  pendingAchievementCount?: Maybe<Scalars['Int']['output']>;
  pointsCollected?: Maybe<Scalars['Int']['output']>;
  rewardsRedeemed?: Maybe<Scalars['Int']['output']>;
  selfCareVisits?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  verifiedAchievementCount?: Maybe<Scalars['Int']['output']>;
};

export type ClientExternalPreview = {
  dateAdded?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasProgressSummary: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  linkedByClientAt?: Maybe<Scalars['String']['output']>;
  progressSummaryUserId?: Maybe<Scalars['Int']['output']>;
  referredAt?: Maybe<Scalars['String']['output']>;
  roiAuthorizedAt?: Maybe<Scalars['String']['output']>;
  roiDeclinedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ReferringProviderStats = {
  referralsMade: Scalars['Int']['output'];
  therapySessionsCompleted: Scalars['Int']['output'];
};

export type ClientProgressSummary = {
  childGoals?: Maybe<Scalars['String']['output']>;
  clientDob?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  familyGoals?: Maybe<Scalars['String']['output']>;
  intakeConcerns?: Maybe<Scalars['String']['output']>;
  intakeDate?: Maybe<Scalars['String']['output']>;
  referringProvider?: Maybe<Scalars['String']['output']>;
  sessionsCompleted?: Maybe<Scalars['String']['output']>;
  sessionsShowRate?: Maybe<Scalars['String']['output']>;
  summaryDate?: Maybe<Scalars['String']['output']>;
};

export type ClientRelationship = {
  user?: Maybe<User>;
};

export type CompletedAssessment = {
  answers: Array<Maybe<CompletedAssessmentAnswer>>;
  assessmentIdentifier: Scalars['String']['output'];
  assessmentParameters?: Maybe<AssessmentParameters>;
  category?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['Int']['output'];
  completedAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scorePossible?: Maybe<Scalars['Int']['output']>;
  subResponses?: Maybe<Array<Maybe<CompletedAssessment>>>;
};

export type CompletedAssessmentAnswer = {
  choiceId?: Maybe<Scalars['Int']['output']>;
  choiceText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  responseText?: Maybe<Scalars['String']['output']>;
};

export type CompletedAssessmentQueryOptions = {
  assessmentIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Configuration = {
  careScreenerReferralUrl: Scalars['String']['output'];
  careScreenerUrl: Scalars['String']['output'];
  completeFormsUrl: Scalars['String']['output'];
  parentSessionAppointmentTypeId: Scalars['String']['output'];
  standardSessionAppointmentTypeId: Scalars['String']['output'];
  stripePublishableKey: Scalars['String']['output'];
};

export type Consent = {
  consentId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  address?: Maybe<Address>;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum ContactPermission {
  SEND_MESSAGE = 'SEND_MESSAGE',
  VIEW_CONTACT = 'VIEW_CONTACT'
}

export type Conversation = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  messages: Array<Maybe<Message>>;
  pendingActions?: Maybe<Array<Maybe<PendingAction>>>;
  permissions: Array<Maybe<ConversationPermission>>;
  read: Scalars['Boolean']['output'];
  recipientReadAt?: Maybe<Scalars['String']['output']>;
  type: ConversationType;
  users: Array<Maybe<User>>;
};

export type ConversationOptions = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  familyId?: InputMaybe<Scalars['Int']['input']>;
  toUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<ConversationType>;
};

export enum ConversationPermission {
  LEAVE = 'LEAVE',
  READ = 'READ',
  WRITE = 'WRITE'
}

export type ConversationQueryOptions = {
  actionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  asUserId?: InputMaybe<Scalars['Int']['input']>;
  conversationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  familyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  messageOffset?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<ConversationType>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum ConversationType {
  CARE_TEAM_EXTERNAL = 'CARE_TEAM_EXTERNAL',
  CARE_TEAM_INTERNAL = 'CARE_TEAM_INTERNAL',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE'
}

export type CreateContactInput = {
  address?: InputMaybe<AddressInput>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalOrganizationInput = {
  name: Scalars['String']['input'];
  partnerType: ExternalOrganizationPartnerType;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalProviderInput = {
  contact: CreateContactInput;
  externalOrganizationId: Scalars['Int']['input'];
};

export type CreateInsuranceCardResult = {
  backImage: FileUploadResult;
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['Int']['output'];
  frontImage: FileUploadResult;
  id: Scalars['Int']['output'];
  userIds: Array<Scalars['Int']['output']>;
};

export type CreateInsuranceInput = {
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  holderAddress: AddressInput;
  holderBirthday: Scalars['String']['input'];
  holderFirstName: Scalars['String']['input'];
  holderGender: Scalars['String']['input'];
  holderLastName: Scalars['String']['input'];
  insurancePlanId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  policyPhoneNumber: Scalars['String']['input'];
  status: InsuranceStatus;
  userId: Scalars['Int']['input'];
};

export type CreatePersonalContactRequest = {
  address?: InputMaybe<AddressInput>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  correlatedReferringProviderId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  externalProviderId?: InputMaybe<Scalars['Int']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: PersonalContactType;
  userId: Scalars['Int']['input'];
};

export type CreateReferralInput = {
  disableTrackerUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  externalOrganizationId: Scalars['Int']['input'];
  externalProviderId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  referredClients: Array<CreateReferredClientInput>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReferredClientInput = {
  contact: CreateContactInput;
  isCareRecipient: Scalars['Boolean']['input'];
  serviceLine?: InputMaybe<Scalars['String']['input']>;
  type: ReferredClientType;
};

export type DailyTip = {
  action?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type Directive = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Document = {
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  users: Array<Maybe<User>>;
};

export type DocumentData = {
  base64: Scalars['String']['output'];
  id: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EhrApiKey = {
  apiKey?: Maybe<Scalars['String']['output']>;
  ehrUserId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type EhrReferringProvider = {
  address?: Maybe<Address>;
  businessName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EhrUser = {
  active?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<EhrUser>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  manateeUserId?: Maybe<Scalars['String']['output']>;
  parents?: Maybe<Array<EhrUser>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providers?: Maybe<Array<EhrUser>>;
};

export type ExternalClientStats = {
  activeClientCount: Scalars['Int']['output'];
  referredClientCount: Scalars['Int']['output'];
  timeframe: TimeFilter;
  totalClientCount: Scalars['Int']['output'];
};

export type ExternalOrganization = {
  canReceiveUpdates: Scalars['Boolean']['output'];
  clientStats?: Maybe<Array<ExternalClientStats>>;
  createdAt: Scalars['String']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  currentProviderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partnerType?: Maybe<ExternalOrganizationPartnerType>;
  providers?: Maybe<Array<ExternalProvider>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<ExternalSourceType>;
  stateCode?: Maybe<Scalars['String']['output']>;
  totalProviderCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export enum ExternalOrganizationPartnerType {
  CHANNEL_PARTNER = 'CHANNEL_PARTNER',
  FAMILY_PRACTICE = 'FAMILY_PRACTICE',
  HEALTH_PLAN = 'HEALTH_PLAN',
  HOSPITAL = 'HOSPITAL',
  OTHER = 'OTHER',
  PEDIATRICIAN = 'PEDIATRICIAN',
  SCHOOL = 'SCHOOL',
  SPECIALIST = 'SPECIALIST',
  URGENT_CARE = 'URGENT_CARE'
}

export type ExternalProvider = {
  clientStats?: Maybe<Array<ExternalClientStats>>;
  contact: Contact;
  createdAt: Scalars['String']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  externalOrganization?: Maybe<ExternalOrganization>;
  externalOrganizationId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastReferralDate?: Maybe<Scalars['String']['output']>;
  receiveUpdates?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<ExternalSourceType>;
  updatedAt: Scalars['String']['output'];
};

export enum ExternalSourceType {
  CLIENT_ADDED = 'CLIENT_ADDED',
  HEALTHIE = 'HEALTHIE',
  IMPORT = 'IMPORT',
  REFERRAL = 'REFERRAL'
}

export type Family = {
  id: Scalars['Int']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type FamilyAnswer = {
  answer: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  questionId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type FamilyQuestion = {
  activeEndDate: Scalars['String']['output'];
  activeStartDate: Scalars['String']['output'];
  answers?: Maybe<Array<Maybe<FamilyAnswer>>>;
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  questionType: FamilyQuestionType;
};

export enum FamilyQuestionType {
  TEXT = 'TEXT'
}

export type Feature = {
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum Feedback {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export enum FeelingDuringCompletion {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type File = {
  base64?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FileInput = {
  base64?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadResult = {
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type Form = {
  completedAt?: Maybe<Scalars['String']['output']>;
  formTemplate: FormTemplate;
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  requestedAt?: Maybe<Scalars['String']['output']>;
  status: FormStatus;
  user: User;
};

export type FormAnswerGroup = {
  customModuleformId: Scalars['String']['output'];
  finished?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
};

export enum FormStatus {
  COMPLETED = 'Completed',
  INCOMPLETE = 'Incomplete'
}

export type FormTemplate = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER'
}

export type Goal = {
  achievedCount?: Maybe<Scalars['Int']['output']>;
  achievements?: Maybe<Array<GoalAchievement>>;
  assignedAt?: Maybe<Scalars['String']['output']>;
  assignedBy?: Maybe<Family>;
  assignedTo?: Maybe<User>;
  assigneeType?: Maybe<AccountType>;
  assignerType?: Maybe<AccountType>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Family>;
  dailyFrequency?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  finalizedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageId?: Maybe<Scalars['Int']['output']>;
  lastAchieved?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  programKey?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  reminderTime1?: Maybe<Scalars['String']['output']>;
  reminderTime2?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Array<Maybe<GoalStat>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};


export type GoalAchievementsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AchievementQueryOptions>;
};

export type GoalAchievement = {
  achievedAt?: Maybe<Scalars['String']['output']>;
  achievedBy?: Maybe<User>;
  feedbackText?: Maybe<Scalars['String']['output']>;
  feelingDuringCompletion?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Goal>;
  goalFeedback?: Maybe<Feedback>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['Boolean']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Family>;
};

export type GoalAchievementFeedback = {
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  feelingDuringCompletion?: InputMaybe<FeelingDuringCompletion>;
  goalFeedback?: InputMaybe<Feedback>;
  goalFeeling?: InputMaybe<Scalars['String']['input']>;
};

export type GoalProgress = {
  goalId?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<AchievementProgress>;
};

export type GoalProgressOptions = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GoalProgressSummary = {
  goalIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  progress?: Maybe<AchievementProgress>;
  subStats?: Maybe<Array<Maybe<GoalProgress>>>;
};

export type GoalQueryOptions = {
  assigneeId?: InputMaybe<Scalars['Int']['input']>;
  assigneeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeActive?: InputMaybe<Scalars['Boolean']['input']>;
  includeAssignable?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  includeFinalized?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoalStat = {
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export enum GoalType {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT'
}

export type GuidingStar = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type Image = {
  image: Scalars['String']['output'];
};

export type InfoPage = {
  items?: Maybe<Array<Maybe<Item>>>;
  key: Scalars['String']['output'];
};

export type InsuranceCard = {
  backImage?: Maybe<File>;
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['Int']['output'];
  frontImage?: Maybe<File>;
  id: Scalars['Int']['output'];
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type InsurancePlan = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payerId?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlanInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InsurancePolicy = {
  groupNumber?: Maybe<Scalars['String']['output']>;
  holderAddress?: Maybe<Address>;
  holderBirthday?: Maybe<Scalars['String']['output']>;
  holderFirstName?: Maybe<Scalars['String']['output']>;
  holderGender?: Maybe<Scalars['String']['output']>;
  holderLastName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  insurancePlan?: Maybe<InsurancePlan>;
  memberId?: Maybe<Scalars['String']['output']>;
  policyPhoneNumber?: Maybe<Scalars['String']['output']>;
  status: InsuranceStatus;
  user: User;
};

export type InsuranceSettings = {
  hasInsuranceUnderReview: Scalars['Boolean']['output'];
  newInsuranceDefaultStatus: InsuranceStatus;
  user: User;
};

export enum InsuranceStatus {
  INACTIVE = 'INACTIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export type Item = {
  data?: Maybe<Scalars['String']['output']>;
  props?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type JournalEntry = {
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type JournalEntryOptions = {
  tag?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type Lesson = {
  completedAt?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Item>>>;
  key: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkedChild = {
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type Message = {
  automated?: Maybe<Scalars['Boolean']['output']>;
  contextUserId?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  from: User;
  hasAttachments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isLatestInConversation?: Maybe<Scalars['Boolean']['output']>;
  mentionedUserIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  message: Scalars['String']['output'];
  templateKey?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplate = {
  category: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MessagingContact = {
  permissions: Array<Maybe<ContactPermission>>;
  user: User;
};

export type Metadata = {
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MigrationCareTeamMembers = {
  accountType?: Maybe<AccountType>;
  ehrUserId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type MigrationEhrUser = {
  active?: Maybe<Scalars['Boolean']['output']>;
  childIds?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  firstName?: Maybe<Scalars['String']['output']>;
  formAnswerGroups: Array<Maybe<FormAnswerGroup>>;
  hasCompletedIntakeForms: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  incompleteFormCount?: Maybe<Scalars['Int']['output']>;
  info?: Maybe<Array<Scalars['String']['output']>>;
  lastName?: Maybe<Scalars['String']['output']>;
  matchScore: Scalars['Float']['output'];
  matchedProperties?: Maybe<Array<Scalars['String']['output']>>;
  parentIds?: Maybe<Array<Scalars['String']['output']>>;
  paymentCards?: Maybe<Array<MigrationPaymentCard>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerIds?: Maybe<Array<Scalars['String']['output']>>;
  requestedFormCount: Scalars['Int']['output'];
};

export type MigrationFamily = {
  children?: Maybe<Array<Maybe<MigrationUser>>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  familyId: Scalars['Int']['output'];
  info?: Maybe<Array<Scalars['String']['output']>>;
  parents?: Maybe<Array<Maybe<MigrationUser>>>;
  state: MigrationState;
};

export type MigrationMetadata = {
  families: MigrationStatistic;
  users: MigrationStatistic;
};

export type MigrationPaymentCard = {
  expiration: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MigrationReport = {
  careTeamMembers?: Maybe<Array<Maybe<MigrationCareTeamMembers>>>;
  families?: Maybe<Array<MigrationFamily>>;
  metadata: MigrationMetadata;
  unlinkedEhrUsers?: Maybe<Array<MigrationEhrUser>>;
};

export type MigrationReportOptions = {
  careTeamMemberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filterWithCareProvider?: InputMaybe<Scalars['Boolean']['input']>;
  includeIncompleteForms?: InputMaybe<Scalars['Boolean']['input']>;
  includeLinkedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnlinkedEhrUsers?: InputMaybe<Scalars['Boolean']['input']>;
  matchUnlinkedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
};

export type MigrationResult = {
  migratedFamilyIds?: Maybe<Array<Scalars['Int']['output']>>;
  migratedUserIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export enum MigrationState {
  INVALID = 'INVALID',
  READY_TO_MIGRATE = 'READY_TO_MIGRATE',
  UNKNOWN = 'UNKNOWN',
  VALID = 'VALID'
}

export type MigrationStatistic = {
  invalidCount: Scalars['Int']['output'];
  invalidIds?: Maybe<Array<Scalars['Int']['output']>>;
  total: Scalars['Int']['output'];
  updatableCount: Scalars['Int']['output'];
  updatableIds?: Maybe<Array<Scalars['Int']['output']>>;
  validCount: Scalars['Int']['output'];
  validIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MigrationUser = {
  createdAt?: Maybe<Scalars['String']['output']>;
  ehrCandidates?: Maybe<Array<MigrationEhrUser>>;
  ehrMatch?: Maybe<MigrationEhrUser>;
  ehrUser?: Maybe<MigrationEhrUser>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  info?: Maybe<Array<Scalars['String']['output']>>;
  lastActiveAt?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providers?: Maybe<Array<Maybe<MigrationCareTeamMembers>>>;
  state: MigrationState;
};

export type Mood = {
  createdAt?: Maybe<Scalars['String']['output']>;
  happyCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  neutralCount?: Maybe<Scalars['Int']['output']>;
  sadCount?: Maybe<Scalars['Int']['output']>;
};

export type MutatedObjects = {
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mutationType?: Maybe<MutationType>;
  type?: Maybe<OperationObjectType>;
};

export type Mutation = {
  acceptTermsAndConditions: Scalars['Boolean']['output'];
  acknowledgeAllNotifications?: Maybe<Scalars['Boolean']['output']>;
  acknowledgeNotification?: Maybe<Scalars['Boolean']['output']>;
  addConnectionToCareTeamMember?: Maybe<AddConnectionResponse>;
  addMoodEntry?: Maybe<Scalars['Boolean']['output']>;
  addPaymentCard: PaymentCardDetails;
  addSelfCareProgress?: Maybe<Scalars['Boolean']['output']>;
  appVersionSupport?: Maybe<Scalars['Boolean']['output']>;
  assignAssessments?: Maybe<Array<Maybe<AssessmentAssignment>>>;
  assignGoal?: Maybe<Goal>;
  assignReward?: Maybe<Reward>;
  cancelAppointment?: Maybe<Scalars['Boolean']['output']>;
  changeChildPassword?: Maybe<User>;
  completeAndVerifyGoal?: Maybe<Goal>;
  completeAssessment?: Maybe<Scalars['Boolean']['output']>;
  completeAssessmentBatch?: Maybe<Scalars['Boolean']['output']>;
  completeGoal?: Maybe<Goal>;
  completeGoalParent?: Maybe<Goal>;
  completeGoalStandaloneClient?: Maybe<Goal>;
  completeLesson?: Maybe<Lesson>;
  completeRedemption?: Maybe<RewardRedemption>;
  createAppointment: Appointment;
  createBillingItem: BillingItem;
  createConversation?: Maybe<Scalars['Int']['output']>;
  createEhrApiKeys?: Maybe<Array<EhrApiKey>>;
  createExternalOrganization: ExternalOrganization;
  createExternalProvider: ExternalProvider;
  createFamilyAnswer?: Maybe<Scalars['Boolean']['output']>;
  createGoal?: Maybe<Goal>;
  createInsuranceCard: CreateInsuranceCardResult;
  createInsurancePolicies: Array<Maybe<InsurancePolicy>>;
  createJournalEntry: Scalars['Int']['output'];
  createMigrationReport: MigrationReport;
  createOneTimeAuthLink: OneTimeAuthLink;
  createOrReplaceGuidingStar?: Maybe<GuidingStar>;
  createPersonalContacts: Array<PersonalContact>;
  createReferral: Referral;
  createRequestedPayment: RequestedPayment;
  createReward?: Maybe<Reward>;
  createSignedConsent?: Maybe<Scalars['Boolean']['output']>;
  createSignedRoiForm?: Maybe<SignedRoiForm>;
  createTask: Task;
  deleteAppointment?: Maybe<Scalars['Boolean']['output']>;
  deleteGoal?: Maybe<Scalars['Boolean']['output']>;
  deleteJournalEntry?: Maybe<Scalars['Boolean']['output']>;
  deleteMessage?: Maybe<Scalars['Boolean']['output']>;
  deletePaymentCard: RemovedPaymentCard;
  deletePendingActions?: Maybe<Scalars['Boolean']['output']>;
  deleteReward?: Maybe<Scalars['Boolean']['output']>;
  deleteTask?: Maybe<Scalars['Boolean']['output']>;
  enrollInProgram?: Maybe<Scalars['Boolean']['output']>;
  finalizeGoal?: Maybe<Goal>;
  leaveConversation?: Maybe<Scalars['Boolean']['output']>;
  markConversationRead?: Maybe<Scalars['Boolean']['output']>;
  migrateClients: MigrationResult;
  parentInviteParent?: Maybe<Scalars['Boolean']['output']>;
  provideLessonFeedback?: Maybe<Lesson>;
  pushNotificationPermission?: Maybe<Scalars['Boolean']['output']>;
  recordAssessmentPromptTime?: Maybe<Scalars['Boolean']['output']>;
  redeemReward?: Maybe<RewardRedemption>;
  registerChild?: Maybe<User>;
  rejectAchievement?: Maybe<GoalAchievement>;
  rejectRedemption?: Maybe<RewardRedemption>;
  removeConnectionToCareTeamMember?: Maybe<Scalars['Boolean']['output']>;
  renewGoal?: Maybe<Goal>;
  requestAccountDeletion?: Maybe<Scalars['Boolean']['output']>;
  requestDirectIntake: RequestDirectIntakeResponse;
  rescheduleAppointment: Appointment;
  runScript: ScriptResult;
  saveSubscriptionSpot?: Maybe<Scalars['Boolean']['output']>;
  sendCareTeamMemberMatchesEmail: ScriptResult;
  sendMessage?: Maybe<Scalars['Boolean']['output']>;
  sendMessageBatch?: Maybe<Scalars['Boolean']['output']>;
  sendProgramSuggestion?: Maybe<Scalars['Boolean']['output']>;
  setCareTeamMemberMatches: Array<Maybe<CareTeamMemberMatch>>;
  setJournalPin?: Maybe<Scalars['Boolean']['output']>;
  shareJournalEntry?: Maybe<Scalars['Boolean']['output']>;
  storePendingInviteGoals?: Maybe<Scalars['Boolean']['output']>;
  submitQuestion?: Maybe<Scalars['Boolean']['output']>;
  subscribeToNotifications: NotificationSubscriptionEvent;
  syncCareTeamConversations?: Maybe<Scalars['Boolean']['output']>;
  syncFamilyConversations?: Maybe<Scalars['Boolean']['output']>;
  therapistDeleteInviteUser?: Maybe<Scalars['Boolean']['output']>;
  therapistInviteUser: Scalars['Int']['output'];
  therapistLinkExistingFamily?: Maybe<Array<Maybe<LinkedChild>>>;
  therapistResendInviteUser?: Maybe<Scalars['Boolean']['output']>;
  unassignGoal?: Maybe<Goal>;
  unassignReward?: Maybe<Reward>;
  uncompleteLesson?: Maybe<Lesson>;
  unsubscribeFromNotifications: NotificationSubscriptionEvent;
  updateAppointment: Appointment;
  updateExternalProvider: ExternalProvider;
  updateGoal?: Maybe<Goal>;
  updateInsurancePolicy: InsurancePolicy;
  updatePaymentCard: PaymentCardDetails;
  updatePushNotificationPreferences?: Maybe<Scalars['Boolean']['output']>;
  updateReward?: Maybe<Reward>;
  verifyAchievement?: Maybe<GoalAchievement>;
};


export type MutationAcknowledgeNotificationArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationAddConnectionToCareTeamMemberArgs = {
  connectToCareMemberUserId: Scalars['Int']['input'];
  connectUserEmail?: InputMaybe<Scalars['String']['input']>;
  connectUserId?: InputMaybe<Scalars['Int']['input']>;
  linkUninvitedUser?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddMoodEntryArgs = {
  mood: Scalars['String']['input'];
};


export type MutationAddPaymentCardArgs = {
  cardTypeLabel: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddSelfCareProgressArgs = {
  action: SelfCareAction;
};


export type MutationAppVersionSupportArgs = {
  version: Scalars['String']['input'];
};


export type MutationAssignAssessmentsArgs = {
  assignments?: InputMaybe<Array<AssessmentAssignmentRequest>>;
};


export type MutationAssignGoalArgs = {
  childId: Scalars['Int']['input'];
  expiresAt: Scalars['String']['input'];
  goalId: Scalars['Int']['input'];
};


export type MutationAssignRewardArgs = {
  childId: Scalars['Int']['input'];
  rewardId: Scalars['Int']['input'];
};


export type MutationCancelAppointmentArgs = {
  id: Scalars['String']['input'];
  isLateChange?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationChangeChildPasswordArgs = {
  childId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
};


export type MutationCompleteAndVerifyGoalArgs = {
  achievedDate?: InputMaybe<Scalars['String']['input']>;
  childId: Scalars['Int']['input'];
  feedback?: InputMaybe<GoalAchievementFeedback>;
  goalId: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteAssessmentArgs = {
  answers: Array<InputMaybe<AssessmentAnswer>>;
  assessmentIdentifier: Scalars['String']['input'];
};


export type MutationCompleteAssessmentBatchArgs = {
  completions: Array<InputMaybe<AssessmentCompletion>>;
};


export type MutationCompleteGoalArgs = {
  feedback?: InputMaybe<GoalAchievementFeedback>;
  goalId: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteGoalParentArgs = {
  achievedDate?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<GoalAchievementFeedback>;
  goalId: Scalars['Int']['input'];
};


export type MutationCompleteGoalStandaloneClientArgs = {
  achievedDate?: InputMaybe<Scalars['String']['input']>;
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  feelingDuringCompletion?: InputMaybe<FeelingDuringCompletion>;
  goalFeedback?: InputMaybe<Feedback>;
  goalFeeling?: InputMaybe<Scalars['String']['input']>;
  goalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCompleteLessonArgs = {
  lessonKey: Scalars['String']['input'];
};


export type MutationCompleteRedemptionArgs = {
  associationId?: InputMaybe<Scalars['Int']['input']>;
  childId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  redemptionId: Scalars['Int']['input'];
  rewardId: Scalars['Int']['input'];
};


export type MutationCreateAppointmentArgs = {
  appointmentTypeId: Scalars['String']['input'];
  attendeeIds: Array<Scalars['Int']['input']>;
  contactMethod: Scalars['String']['input'];
  date: Scalars['String']['input'];
  recurringCount?: InputMaybe<Scalars['Int']['input']>;
  recurringInterval?: InputMaybe<RecurringAppointmentInterval>;
};


export type MutationCreateBillingItemArgs = {
  requestedPaymentId: Scalars['Int']['input'];
  shouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCustomerDetailId: Scalars['Int']['input'];
  stripeIdempotencyKey: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCreateConversationArgs = {
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationCreateEhrApiKeysArgs = {
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationCreateExternalOrganizationArgs = {
  input: CreateExternalOrganizationInput;
};


export type MutationCreateExternalProviderArgs = {
  input: CreateExternalProviderInput;
};


export type MutationCreateFamilyAnswerArgs = {
  answer?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateGoalArgs = {
  assignedTo: Scalars['Int']['input'];
  createUnassignedCopy?: InputMaybe<Scalars['Boolean']['input']>;
  dailyFrequency?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['String']['input'];
  expiresAt: Scalars['String']['input'];
  imageId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  reminderTime1?: InputMaybe<Scalars['String']['input']>;
  reminderTime2?: InputMaybe<Scalars['String']['input']>;
  unassignedCopyReminderTime1?: InputMaybe<Scalars['String']['input']>;
  unassignedCopyReminderTime2?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};


export type MutationCreateInsuranceCardArgs = {
  backImage: FileInput;
  frontImage: FileInput;
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationCreateInsurancePoliciesArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateInsuranceInput>>>;
};


export type MutationCreateJournalEntryArgs = {
  options: JournalEntryOptions;
};


export type MutationCreateMigrationReportArgs = {
  options: MigrationReportOptions;
};


export type MutationCreateOneTimeAuthLinkArgs = {
  externalProviderId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOrReplaceGuidingStarArgs = {
  description: Scalars['String']['input'];
};


export type MutationCreatePersonalContactsArgs = {
  contacts: Array<CreatePersonalContactRequest>;
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateRequestedPaymentArgs = {
  appointmentId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['String']['input'];
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  serviceProvided?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationCreateRewardArgs = {
  assignedTo: Scalars['Int']['input'];
  cost: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateSignedConsentArgs = {
  childId: Scalars['Int']['input'];
  consentId: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
};


export type MutationCreateSignedRoiFormArgs = {
  clientId: Scalars['Int']['input'];
  consentProvided: Scalars['Boolean']['input'];
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  releaseToContactId: Scalars['Int']['input'];
  signatureBase64: Scalars['String']['input'];
  signatureMimeType: Scalars['String']['input'];
};


export type MutationCreateTaskArgs = {
  clientId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeleteAppointmentArgs = {
  deleteRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type MutationDeleteGoalArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  goalId: Scalars['Int']['input'];
};


export type MutationDeleteJournalEntryArgs = {
  entryId: Scalars['Int']['input'];
};


export type MutationDeleteMessageArgs = {
  messageId: Scalars['Int']['input'];
};


export type MutationDeletePaymentCardArgs = {
  cardId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeletePendingActionsArgs = {
  conversationIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationDeleteRewardArgs = {
  childId: Scalars['Int']['input'];
  rewardId: Scalars['Int']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationEnrollInProgramArgs = {
  programKey: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFinalizeGoalArgs = {
  childId: Scalars['Int']['input'];
  goalId: Scalars['Int']['input'];
};


export type MutationLeaveConversationArgs = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['Int']['input'];
};


export type MutationMigrateClientsArgs = {
  careTeamMemberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  enableCareDeskFeature?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationParentInviteParentArgs = {
  email: Scalars['String']['input'];
  programKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProvideLessonFeedbackArgs = {
  feedback: Scalars['String']['input'];
  lessonKey: Scalars['String']['input'];
};


export type MutationPushNotificationPermissionArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationRedeemRewardArgs = {
  rewardId: Scalars['Int']['input'];
};


export type MutationRegisterChildArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  ehrUserId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePlatform?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  theme?: InputMaybe<Scalars['String']['input']>;
  therapistId?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timeZoneOffset?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type MutationRejectAchievementArgs = {
  achievementId: Scalars['Int']['input'];
  associationId?: InputMaybe<Scalars['Int']['input']>;
  childId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRejectRedemptionArgs = {
  associationId?: InputMaybe<Scalars['Int']['input']>;
  childId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  redemptionId: Scalars['Int']['input'];
  rewardId: Scalars['Int']['input'];
};


export type MutationRemoveConnectionToCareTeamMemberArgs = {
  disconnectAllCareTeamMembers?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectCareMemberUserId?: InputMaybe<Scalars['Int']['input']>;
  disconnectUserId: Scalars['Int']['input'];
};


export type MutationRenewGoalArgs = {
  childId: Scalars['Int']['input'];
  goalId: Scalars['Int']['input'];
  newExpirationDate: Scalars['String']['input'];
};


export type MutationRequestAccountDeletionArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRequestDirectIntakeArgs = {
  careScreenerSubmissionId: Scalars['Int']['input'];
};


export type MutationRescheduleAppointmentArgs = {
  date: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isLateChange?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationRunScriptArgs = {
  input?: InputMaybe<ScriptRequest>;
};


export type MutationSendCareTeamMemberMatchesEmailArgs = {
  contextUserId: Scalars['Int']['input'];
  emailRecipientUserIds: Array<Scalars['Int']['input']>;
};


export type MutationSendMessageArgs = {
  options: SendMessageOptions;
};


export type MutationSendMessageBatchArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<ConversationOptions>>>;
};


export type MutationSendProgramSuggestionArgs = {
  message: Scalars['String']['input'];
};


export type MutationSetCareTeamMemberMatchesArgs = {
  careTeamMemberIds: Array<Scalars['Int']['input']>;
  retainCareCoordinatorMatches?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationSetJournalPinArgs = {
  journalPin: Scalars['String']['input'];
};


export type MutationShareJournalEntryArgs = {
  entryId?: InputMaybe<Scalars['Int']['input']>;
  recipientIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationStorePendingInviteGoalsArgs = {
  goals?: InputMaybe<Array<InputMaybe<PendingGoal>>>;
  inviteId: Scalars['Int']['input'];
  timeZoneOffset: Scalars['String']['input'];
};


export type MutationSubmitQuestionArgs = {
  message: Scalars['String']['input'];
  type?: InputMaybe<QuestionType>;
};


export type MutationSubscribeToNotificationsArgs = {
  deliveryType: NotificationDeliveryType;
  userId: Scalars['Int']['input'];
};


export type MutationSyncCareTeamConversationsArgs = {
  providerId: Scalars['Int']['input'];
};


export type MutationSyncFamilyConversationsArgs = {
  familyId: Scalars['Int']['input'];
};


export type MutationTherapistDeleteInviteUserArgs = {
  inviteId: Scalars['Int']['input'];
};


export type MutationTherapistInviteUserArgs = {
  accountType: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primaryTherapistId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTherapistLinkExistingFamilyArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  parentEmail: Scalars['String']['input'];
  primaryTherapistId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTherapistResendInviteUserArgs = {
  inviteId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnassignGoalArgs = {
  goalId: Scalars['Int']['input'];
};


export type MutationUnassignRewardArgs = {
  rewardId: Scalars['Int']['input'];
};


export type MutationUncompleteLessonArgs = {
  lessonKey: Scalars['String']['input'];
};


export type MutationUnsubscribeFromNotificationsArgs = {
  deliveryType: NotificationDeliveryType;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateAppointmentArgs = {
  appointmentTypeId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  pmStatus?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateExternalProviderArgs = {
  id: Scalars['Int']['input'];
  input: UpdateExternalProviderInput;
};


export type MutationUpdateGoalArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  dailyFrequency?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['String']['input'];
  goalId: Scalars['Int']['input'];
  imageId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  reminderTime1?: InputMaybe<Scalars['String']['input']>;
  reminderTime2?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};


export type MutationUpdateInsurancePolicyArgs = {
  policyId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdatePaymentCardArgs = {
  cardId: Scalars['String']['input'];
  cardTypeLabel: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUpdatePushNotificationPreferencesArgs = {
  preferences: Array<InputMaybe<NotificationPreference>>;
};


export type MutationUpdateRewardArgs = {
  childId: Scalars['Int']['input'];
  cost: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  rewardId: Scalars['Int']['input'];
};


export type MutationVerifyAchievementArgs = {
  achievementId: Scalars['Int']['input'];
  associationId?: InputMaybe<Scalars['Int']['input']>;
  childId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
};

export enum MutationType {
  CREATE = 'Create',
  UPDATE = 'Update'
}

export type Notification = {
  associationId?: Maybe<Scalars['Int']['output']>;
  associationStatus?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  clickAction: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: NotificationTrigger;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum NotificationDeliveryType {
  ALL = 'ALL',
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export type NotificationList = {
  hasPendingGoal?: Maybe<Scalars['Boolean']['output']>;
  hasPendingRedemption?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationPreference = {
  notification: Scalars['String']['input'];
  preference: Scalars['String']['input'];
};

export type NotificationPreferenceT = {
  notification: Scalars['String']['output'];
  preference: Scalars['String']['output'];
};

export type NotificationSubscriptionEvent = {
  contactAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deliveryType: NotificationDeliveryType;
  id: Scalars['Int']['output'];
  type: SubscriptionEventType;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type NotificationTrigger = {
  achievementId?: Maybe<Scalars['Int']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  goalId?: Maybe<Scalars['Int']['output']>;
  redemptionId?: Maybe<Scalars['Int']['output']>;
  rewardId?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OneTimeAuthLink = {
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum OperationObjectType {
  APPOINTMENT = 'Appointment',
  CARESCREENERSUBMISSION = 'CareScreenerSubmission',
  DEFAULT = 'Default',
  EHRUSER = 'EhrUser',
  EMAIL = 'Email',
  JOB = 'Job',
  MESSAGE = 'Message',
  USER = 'User'
}

export type Parent = {
  accountType?: Maybe<AccountType>;
  achievements?: Maybe<Array<GoalAchievement>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  ehrUserId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  id: Scalars['Int']['output'];
  lastActiveAt?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};


export type ParentAchievementsArgs = {
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AchievementQueryOptions>;
};


export type ParentGoalsArgs = {
  options?: InputMaybe<GoalQueryOptions>;
};

export type PaymentCardDetails = {
  bankType?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  cardTypeLabel?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  ehrUserId?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['String']['output']>;
  expiringNextMonth?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  sourceStatus?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type PendingAction = {
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  reason: PendingActionType;
};

export enum PendingActionType {
  MENTIONED = 'MENTIONED',
  UNREAD_MESSAGE = 'UNREAD_MESSAGE'
}

export type PendingGoal = {
  goalId: Scalars['Int']['input'];
  goalType: GoalType;
};

export type PersonalContact = {
  address?: Maybe<Address>;
  businessName?: Maybe<Scalars['String']['output']>;
  correlatedReferringProviderId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalOrganizationId?: Maybe<Scalars['Int']['output']>;
  externalProviderId?: Maybe<Scalars['Int']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  type: PersonalContactType;
  userId: Scalars['Int']['output'];
};

export enum PersonalContactType {
  PRIMARY_CARE_PROVIDER = 'PRIMARY_CARE_PROVIDER'
}

export type Predicates = {
  careTeamMemberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  whereActive?: InputMaybe<Scalars['Boolean']['input']>;
  whereInEhr?: InputMaybe<Scalars['Boolean']['input']>;
  whereRelatedToCareProvider?: InputMaybe<Scalars['Boolean']['input']>;
  whereRelatedToCareTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  whereTestUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricingInfo = {
  cptCodeId?: Maybe<Scalars['String']['output']>;
  lateChangeFee?: Maybe<Scalars['Float']['output']>;
  lateChangeFeeHoursBeforeAppointment?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type ProcessedObjects = {
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OperationObjectType>;
};

export type Program = {
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enrolledAt?: Maybe<Scalars['String']['output']>;
  infoPage?: Maybe<InfoPage>;
  key: Scalars['String']['output'];
  memberInclusionType?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Array<Maybe<Metadata>>>;
  purchaseType?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<Section>>>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProgramEnrollment = {
  programKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProgramQueryOptions = {
  maxApiVersion?: InputMaybe<Scalars['String']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramVersion = {
  apiVersion?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  achievementImage: Image;
  achievements?: Maybe<Array<GoalAchievement>>;
  activityFeed?: Maybe<Array<Maybe<ActivityItem>>>;
  adultGoals: Array<Maybe<Goal>>;
  appointment: Appointment;
  appointmentTypes: Array<AppointmentType>;
  appointments?: Maybe<Array<Maybe<Appointment>>>;
  assessmentAssignments?: Maybe<Array<AssessmentAssignment>>;
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  assessmentsAssignable: AssessmentsAssignableReturn;
  assessmentsAssigned: AssessmentsAssignedReturn;
  availableDays?: Maybe<AvailableDaysQueryResponse>;
  availableTimeSlots?: Maybe<Array<Maybe<AvailableTimeSlot>>>;
  billingItems: Array<Maybe<BillingItem>>;
  canReceiveMessages?: Maybe<Array<Maybe<CanReceiveMessages>>>;
  careScreeners: Array<Maybe<CareScreener>>;
  careTeam?: Maybe<CareTeam>;
  careTeamMemberMatches: Array<Maybe<CareTeamMemberMatch>>;
  childDetails?: Maybe<User>;
  childGoals: Array<Maybe<Goal>>;
  childMood?: Maybe<Mood>;
  childParents?: Maybe<Array<Maybe<Parent>>>;
  childProgressReport?: Maybe<Array<Maybe<ChildProgressReport>>>;
  childrenByParentEmail?: Maybe<Array<Maybe<User>>>;
  clientExternalPreviews: Array<ClientExternalPreview>;
  clientProgressSummary?: Maybe<ClientProgressSummary>;
  completedAssessments?: Maybe<Array<Maybe<CompletedAssessment>>>;
  configuration: Configuration;
  contacts: Array<Maybe<MessagingContact>>;
  conversations: Array<Maybe<Conversation>>;
  dailyTip?: Maybe<DailyTip>;
  documents: Array<Maybe<Document>>;
  downloadDocument: DocumentData;
  ehrReferringProviders?: Maybe<Array<Maybe<EhrReferringProvider>>>;
  ehrUsers: Array<Maybe<EhrUser>>;
  externalOrganizations: Array<ExternalOrganization>;
  families?: Maybe<Array<Maybe<Family>>>;
  familyGoals: Array<Maybe<Goal>>;
  familyMembers?: Maybe<Array<Maybe<User>>>;
  familyQuestions: Array<Maybe<FamilyQuestion>>;
  featureToggles: Array<Maybe<Feature>>;
  forms: Array<Maybe<Form>>;
  getExternalProviders: Array<Maybe<ExternalProvider>>;
  goal?: Maybe<Goal>;
  goalProgress?: Maybe<GoalProgressSummary>;
  goals: Array<Maybe<Goal>>;
  guidingStars: Array<GuidingStar>;
  hasAcceptedTermsAndConditions: Scalars['Boolean']['output'];
  insuranceCards: Array<InsuranceCard>;
  insurancePlans: Array<Maybe<InsurancePlan>>;
  insurancePolicies: Array<Maybe<InsurancePolicy>>;
  insuranceSettings: Array<Maybe<InsuranceSettings>>;
  journalEntries: Array<Maybe<JournalEntry>>;
  latestProgramVersion?: Maybe<ProgramVersion>;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  me: User;
  messageAttachments?: Maybe<Array<Maybe<File>>>;
  messageTemplates?: Maybe<Array<Maybe<MessageTemplate>>>;
  nextAvailableDays: Array<AvailableDay>;
  notifications?: Maybe<Array<Notification>>;
  parentRewards: Array<Maybe<Reward>>;
  parentTherapist?: Maybe<Therapist>;
  paymentCards: Array<Maybe<PaymentCardDetails>>;
  personalContacts?: Maybe<Array<Maybe<PersonalContact>>>;
  programEnrollment?: Maybe<ProgramEnrollment>;
  programs?: Maybe<Array<Maybe<Program>>>;
  pushNotificationPreferences?: Maybe<Array<Maybe<NotificationPreferenceT>>>;
  redemptions?: Maybe<Array<RewardRedemption>>;
  referral?: Maybe<Referral>;
  referrals: Array<Referral>;
  referringProviderStats: ReferringProviderStats;
  referringProviders?: Maybe<Array<Maybe<EhrReferringProvider>>>;
  registrationChildren?: Maybe<Array<Maybe<RegistrationChild>>>;
  requestedPayments: Array<Maybe<RequestedPayment>>;
  reward?: Maybe<Reward>;
  rewards: Array<Maybe<Reward>>;
  schedulingDirectives: Array<SchedulingDirective>;
  searchExternalOrganizations: Array<ExternalOrganization>;
  searchExternalProviders: Array<ExternalProvider>;
  standaloneClientGoals: Array<Maybe<Goal>>;
  tasks: Array<Maybe<Task>>;
  therapistChildParents?: Maybe<Array<Maybe<ChildParentRelationship>>>;
  therapistCustomGoals: Array<Maybe<Goal>>;
  therapistInvites?: Maybe<Array<Maybe<TherapistToUserInvite>>>;
  tmpNotifications?: Maybe<NotificationList>;
  unreadConversationCount: Scalars['Int']['output'];
  users: Array<Maybe<User>>;
};


export type QueryAchievementImageArgs = {
  achievementId: Scalars['Int']['input'];
  assigneeId: Scalars['Int']['input'];
  goalId: Scalars['Int']['input'];
};


export type QueryAchievementsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AchievementQueryOptions>;
};


export type QueryActivityFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryAdultGoalsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<GoalQueryOptions>;
};


export type QueryAppointmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppointmentsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAssessmentAssignmentsArgs = {
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAssessmentsArgs = {
  options?: InputMaybe<AssessmentQueryOptions>;
};


export type QueryAssessmentsAssignableArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAvailableDaysArgs = {
  appointmentTypeId: Scalars['String']['input'];
  contactMethod: Scalars['String']['input'];
  dateInMonth: Scalars['String']['input'];
  recurringCount?: InputMaybe<Scalars['Int']['input']>;
  recurringInterval?: InputMaybe<RecurringAppointmentInterval>;
  reschedulingAppointmentId?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryAvailableTimeSlotsArgs = {
  appointmentTypeId: Scalars['String']['input'];
  contactMethod: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  recurringCount?: InputMaybe<Scalars['Int']['input']>;
  recurringInterval?: InputMaybe<RecurringAppointmentInterval>;
  reschedulingAppointmentId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryBillingItemsArgs = {
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryCanReceiveMessagesArgs = {
  therapistIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryCareScreenersArgs = {
  filterByLatest?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCareTeamMemberMatchesArgs = {
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryChildDetailsArgs = {
  childId: Scalars['Int']['input'];
};


export type QueryChildGoalsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GoalQueryOptions>;
};


export type QueryChildMoodArgs = {
  childId: Scalars['Int']['input'];
  daysBack?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChildParentsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChildProgressReportArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChildrenByParentEmailArgs = {
  parentEmail: Scalars['String']['input'];
};


export type QueryClientExternalPreviewsArgs = {
  externalProviderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryClientProgressSummaryArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryReferringProviderStatsArgs = {
  externalProviderId: Scalars['Int']['input'];
};


export type QueryCompletedAssessmentsArgs = {
  options?: InputMaybe<CompletedAssessmentQueryOptions>;
};


export type QueryConversationsArgs = {
  options?: InputMaybe<ConversationQueryOptions>;
};


export type QueryDocumentsArgs = {
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryDownloadDocumentArgs = {
  id: Scalars['String']['input'];
  method: Scalars['String']['input'];
};


export type QueryEhrReferringProvidersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEhrUsersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalOrganizationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  providerLimit?: InputMaybe<Scalars['Int']['input']>;
  providerOffset?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFamiliesArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryFamilyQuestionsArgs = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFormsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<FormStatus>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryGetExternalProvidersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  goalId: Scalars['Int']['input'];
};


export type QueryGoalProgressArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<GoalProgressOptions>;
};


export type QueryGoalsArgs = {
  options?: InputMaybe<GoalQueryOptions>;
};


export type QueryGuidingStarsArgs = {
  userIds: Array<Scalars['Int']['input']>;
};


export type QueryInsuranceCardsArgs = {
  filterByLatest?: InputMaybe<Scalars['Boolean']['input']>;
  includeImageData?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryInsurancePlansArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<SearchType>;
};


export type QueryInsurancePoliciesArgs = {
  status?: InputMaybe<Array<InputMaybe<InsuranceStatus>>>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryInsuranceSettingsArgs = {
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryMessageAttachmentsArgs = {
  asUserId?: InputMaybe<Scalars['Int']['input']>;
  includeData?: InputMaybe<Scalars['Boolean']['input']>;
  messageId: Scalars['Int']['input'];
};


export type QueryNextAvailableDaysArgs = {
  appointmentTypeId: Scalars['String']['input'];
  contactMethod: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryNotificationsArgs = {
  allNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentCardsArgs = {
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryPersonalContactsArgs = {
  userIds: Array<Scalars['Int']['input']>;
};


export type QueryProgramsArgs = {
  options?: InputMaybe<ProgramQueryOptions>;
};


export type QueryRedemptionsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReferralArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReferralsArgs = {
  externalOrganizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  externalProviderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  referredClientUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferringProvidersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestedPaymentsArgs = {
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryRewardArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
  rewardId: Scalars['Int']['input'];
};


export type QueryRewardsArgs = {
  childId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchedulingDirectivesArgs = {
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QuerySearchExternalOrganizationsArgs = {
  searchText: Scalars['String']['input'];
};


export type QuerySearchExternalProvidersArgs = {
  externalOrganizationId: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
};


export type QueryStandaloneClientGoalsArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GoalQueryOptions>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTasksArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryTmpNotificationsArgs = {
  childId: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionType {
  BILLING = 'BILLING',
  CARE_COORDINATION = 'CARE_COORDINATION',
  OTHER = 'OTHER',
  TECH_SUPPORT = 'TECH_SUPPORT'
}

export enum RecurringAppointmentInterval {
  BIWEEKLY = 'Biweekly',
  WEEKLY = 'Weekly'
}

export type Referral = {
  careScreenerUrlParams?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  externalOrganization?: Maybe<ExternalOrganization>;
  externalOrganizationId?: Maybe<Scalars['Int']['output']>;
  externalProvider?: Maybe<ExternalProvider>;
  externalProviderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  referralUuid?: Maybe<Scalars['String']['output']>;
  referredClients: Array<ReferredClient>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type ReferredClient = {
  careScreenerId?: Maybe<Scalars['Int']['output']>;
  contact: Contact;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCareRecipient: Scalars['Boolean']['output'];
  proxyUserId?: Maybe<Scalars['Int']['output']>;
  serviceLine?: Maybe<Scalars['String']['output']>;
  type: ReferredClientType;
  updatedAt: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum ReferredClientType {
  CAREGIVER = 'CAREGIVER',
  CHILD = 'CHILD'
}

export type RegistrationChild = {
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  ehrUserId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum RelationshipType {
  PARENT = 'PARENT',
  THERAPIST = 'THERAPIST'
}

export type RemovedPaymentCard = {
  id: Scalars['Int']['output'];
};

export type RequestDirectIntakeResponse = {
  careCoordinator?: Maybe<User>;
};

export type RequestedPayment = {
  alertForPayment: Scalars['Boolean']['output'];
  appointmentId?: Maybe<Scalars['String']['output']>;
  client?: Maybe<User>;
  debt?: Maybe<Scalars['Float']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceDate?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<User>;
  serviceDate?: Maybe<Scalars['String']['output']>;
  serviceProvided?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ResourceRefCollection = {
  ids?: Maybe<Array<Scalars['String']['output']>>;
  type: ResourceType;
};

export enum ResourceType {
  APPOINTMENT = 'Appointment',
  CARETEAMMEMBER = 'CareTeamMember',
  CLIENT = 'Client',
  CONVERSATION = 'Conversation',
  EHRUSER = 'EhrUser',
  FAMILY = 'Family',
  USER = 'User'
}

export type Reward = {
  assignedTo?: Maybe<User>;
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Family>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  redemptions?: Maybe<Array<RewardRedemption>>;
};

export type RewardRedemption = {
  approvedBy?: Maybe<Family>;
  cost?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  redeemedAt?: Maybe<Scalars['String']['output']>;
  redeemedBy?: Maybe<User>;
  reward?: Maybe<Reward>;
};

export type SchedulingDirective = {
  schedulableAppointmentTypes: Array<AppointmentType>;
  userId: Scalars['Int']['output'];
};

export type ScriptRequest = {
  clientPredicates?: InputMaybe<Predicates>;
  directives?: InputMaybe<Array<Directive>>;
  familyPredicates?: InputMaybe<Predicates>;
  name: Scalars['String']['input'];
  userPredicates?: InputMaybe<Predicates>;
};

export type ScriptResult = {
  errors?: Maybe<Array<Scalars['String']['output']>>;
  mutatedObjects?: Maybe<Array<MutatedObjects>>;
  operationName?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['String']['output']>;
  processedObjects?: Maybe<Array<ProcessedObjects>>;
  updatedResources?: Maybe<Array<ResourceRefCollection>>;
};

export enum SearchType {
  EXACT = 'EXACT',
  SIMILAR = 'SIMILAR'
}

export type Section = {
  key?: Maybe<Scalars['String']['output']>;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SelfCareAction {
  GO_TO_CHAT = 'GO_TO_CHAT',
  GO_TO_JOURNAL = 'GO_TO_JOURNAL',
  I_DID_IT = 'I_DID_IT'
}

export type SendMessageOptions = {
  attachments?: InputMaybe<Array<InputMaybe<FileInput>>>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  mentionedUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  message: Scalars['String']['input'];
  templateKey?: InputMaybe<Scalars['String']['input']>;
  toUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SignedRoiForm = {
  clientId: Scalars['Int']['output'];
  consentProvided: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  releaseToContactId: Scalars['Int']['output'];
  revokedAt?: Maybe<Scalars['String']['output']>;
  signatureBase64: Scalars['String']['output'];
  signatureMimeType: Scalars['String']['output'];
  signedByUserId: Scalars['Int']['output'];
};

export enum SubscriptionEventType {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED'
}

export type Task = {
  clientId?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type Therapist = {
  consents?: Maybe<Array<Maybe<Consent>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  therapistId?: Maybe<Scalars['Int']['output']>;
};

export enum TimeFilter {
  ALL_TIME = 'ALL_TIME',
  MONTHLY = 'MONTHLY'
}

export type UpdateExternalProviderInput = {
  receiveUpdates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  accountType: AccountType;
  activeClient?: Maybe<Scalars['Boolean']['output']>;
  careCoordinators?: Maybe<Array<UserRelationship>>;
  careScreeners: Array<Maybe<CareScreener>>;
  children?: Maybe<Array<UserRelationship>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  credentialing?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  ehrUserId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  journalPin?: Maybe<Scalars['String']['output']>;
  lastActiveAt?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licensedStates?: Maybe<Array<Scalars['String']['output']>>;
  lifetimePoints?: Maybe<Scalars['Int']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  parentCoaches?: Maybe<Array<UserRelationship>>;
  parents?: Maybe<Array<UserRelationship>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pointsBalance?: Maybe<Scalars['Int']['output']>;
  pointsPendingBalance?: Maybe<Scalars['Int']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Maybe<Reward>>>;
  status: UserStatus;
  theme?: Maybe<Scalars['String']['output']>;
  therapists?: Maybe<Array<UserRelationship>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserChildrenArgs = {
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAssessmentsAssignable = {
  assessmentIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignable: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export type UserRelationship = {
  primary?: Maybe<Scalars['Boolean']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  relationshipType?: Maybe<RelationshipType>;
  user: User;
};

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  UNVERIFIED = 'UNVERIFIED'
}

export type AssessmentsAssignableReturn = {
  assessmentIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignable: Scalars['Boolean']['output'];
  userAssessments?: Maybe<Array<Maybe<UserAssessmentsAssignable>>>;
};

export type AssessmentsAssignedReturn = {
  assessmentIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assigned: Scalars['Boolean']['output'];
  delayable: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  prompt: Scalars['Boolean']['output'];
};

export type TherapistToUserInvite = {
  accountType: AccountType;
  clientName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  inviteId: Scalars['Int']['output'];
};

export type GetHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeQuery = { me: { id: number, accountType: AccountType, firstName: string, lastName?: string, providerName?: string }, assessments?: Array<{ identifier: string, name: string, type: string, isArchived?: boolean, categoryCriteria?: Array<{ order: number, category: string, clinicalCategory?: string, minScore: number, maxScore: number, color: string }>, subAssessments?: Array<{ identifier: string, name: string, type: string, isArchived?: boolean, categoryCriteria?: Array<{ order: number, category: string, clinicalCategory?: string, minScore: number, maxScore: number, color: string }> }> }>, canReceiveMessages?: Array<{ canReceiveMessages: boolean }>, messageTemplates?: Array<{ id: number, key: string, name: string, category: string, message: string }> };

export type GetChildrenQueryVariables = Exact<{
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetChildrenQuery = { me: { children?: Array<{ user: { id: number, accountType: AccountType, firstName: string, lastName?: string, dateOfBirth?: string, pointsBalance?: number, createdAt?: string, username?: string, email?: string, lastActiveAt?: string, timeZone?: string, familyId: number, ehrUserId?: string, activeClient?: boolean, groupName?: string, parents?: Array<{ user: { id: number, firstName: string, lastName?: string, activeClient?: boolean, groupName?: string, ehrUserId?: string, email?: string } }> } }> } };

export type GetTherapistCustomGoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistCustomGoalsQuery = { therapistCustomGoals: Array<{ id: number, name: string, value?: number, imageId?: number }> };

export type GetTherapistCustomParentGoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistCustomParentGoalsQuery = { goals: Array<{ id: number, name: string, description?: string, dueAt?: string, assignedAt?: string, reminderTime1?: string, reminderTime2?: string }> };

export type GetChildMoodQueryVariables = Exact<{
  childId: Scalars['Int']['input'];
  daysBack?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetChildMoodQuery = { childMood?: { sadCount?: number, neutralCount?: number, happyCount?: number } };

export type GetChildDetailsQueryVariables = Exact<{
  childId: Scalars['Int']['input'];
}>;


export type GetChildDetailsQuery = { childDetails?: { id: number, accountType: AccountType, firstName: string, lastName?: string, lifetimePoints?: number, createdAt?: string, therapists?: Array<{ user: { id: number } }> }, childParents?: Array<{ id: number, firstName?: string, lastName?: string, email?: string, phoneNumber?: string, createdAt?: string, lastActiveAt?: string, timeZone?: string, accountType?: AccountType, ehrUserId?: string, goals?: Array<{ id: number, name: string, description?: string, dueAt?: string, assignedAt?: string, reminderTime1?: string, reminderTime2?: string, achievements?: Array<{ id: number, achievedAt?: string }> }>, achievements?: Array<{ id: number, achievedAt?: string, goalFeedback?: Feedback, feelingDuringCompletion?: string, feedbackText?: string, goal?: { id: number, name: string } }> }>, childGoals: Array<{ id: number, name: string, dueAt?: string, dailyFrequency?: number, expiresAt?: string, finalizedAt?: string, value?: number, assignedAt?: string, assignerType?: AccountType, reminderTime1?: string, achievements?: Array<{ id: number, achievedAt?: string, points?: number, image?: boolean }> }>, achievements?: Array<{ id: number, achievedAt?: string, points?: number, goalFeedback?: Feedback, feelingDuringCompletion?: string, feedbackText?: string, goal?: { id: number, name: string, dueAt?: string, assignedAt?: string, expiresAt?: string } }>, rewards: Array<{ id: number, name?: string, redemptions?: Array<{ redeemedAt?: string, cost?: number, approvedBy?: { id: number } }> }> };

export type GetAssessmentAssignmentsAndCompletionsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  assessmentIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetAssessmentAssignmentsAndCompletionsQuery = { assessmentsAssignable: { assessmentIdentifiers?: Array<string>, assignable: boolean, userAssessments?: Array<{ userId: number, assessmentIdentifiers?: Array<string> }> }, assessmentAssignments?: Array<{ assigneeId: number, assessmentIdentifier: string, assessmentParameters?: { subjectUserId?: number } }>, completedAssessments?: Array<{ id: number, clientId: number, assessmentIdentifier: string, category?: string, score?: number, scorePossible?: number, completedAt: string, name?: string, isArchived?: boolean, answers: Array<{ questionId: number, choiceId?: number, questionText: string, choiceText?: string, responseText?: string }>, assessmentParameters?: { subjectUserId?: number }, subResponses?: Array<{ id: number, clientId: number, assessmentIdentifier: string, category?: string, score?: number, scorePossible?: number, completedAt: string, name?: string, isArchived?: boolean, answers: Array<{ questionId: number, choiceId?: number, questionText: string, choiceText?: string }>, assessmentParameters?: { subjectUserId?: number } }> }> };

export type AssignAssessmentsMutationVariables = Exact<{
  assignments?: InputMaybe<Array<AssessmentAssignmentRequest> | AssessmentAssignmentRequest>;
}>;


export type AssignAssessmentsMutation = { assignAssessments?: Array<{ assigneeId: number }> };

export type GetAdultRewardsQueryVariables = Exact<{
  childId: Scalars['Int']['input'];
}>;


export type GetAdultRewardsQuery = { childDetails?: { id: number, firstName: string }, rewards: Array<{ id: number, name?: string, description?: string, imageId: number, cost?: number, assignedTo?: { id: number } }> };

export type GetAdultGoalsQueryVariables = Exact<{
  childId: Scalars['Int']['input'];
}>;


export type GetAdultGoalsQuery = { childDetails?: { id: number, accountType: AccountType, firstName: string, theme?: string }, adultGoals: Array<{ id: number, name: string, description?: string, dueAt?: string, dailyFrequency?: number, reminderTime1?: string, reminderTime2?: string, expiresAt?: string, value?: number, imageId?: number, readOnly?: boolean, assignerType?: AccountType, assignedTo?: { id: number } }> };

export type GetGoalAchievementImageQueryVariables = Exact<{
  assigneeId: Scalars['Int']['input'];
  goalId: Scalars['Int']['input'];
  achievementId: Scalars['Int']['input'];
}>;


export type GetGoalAchievementImageQuery = { achievementImage: { image: string } };

export type CreateGoalMutationVariables = Exact<{
  assignedTo: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['String']['input'];
  dailyFrequency?: InputMaybe<Scalars['Int']['input']>;
  reminderTime1?: InputMaybe<Scalars['String']['input']>;
  reminderTime2?: InputMaybe<Scalars['String']['input']>;
  expiresAt: Scalars['String']['input'];
  value: Scalars['Int']['input'];
  imageId: Scalars['Int']['input'];
  createUnassignedCopy?: InputMaybe<Scalars['Boolean']['input']>;
  unassignedCopyReminderTime1?: InputMaybe<Scalars['String']['input']>;
  unassignedCopyReminderTime2?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGoalMutation = { createGoal?: { id: number } };

export type UpdateGoalMutationVariables = Exact<{
  goalId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['String']['input'];
  dailyFrequency?: InputMaybe<Scalars['Int']['input']>;
  reminderTime1?: InputMaybe<Scalars['String']['input']>;
  reminderTime2?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
  imageId: Scalars['Int']['input'];
}>;


export type UpdateGoalMutation = { updateGoal?: { id: number } };

export type DeleteGoalMutationVariables = Exact<{
  goalId: Scalars['Int']['input'];
}>;


export type DeleteGoalMutation = { deleteGoal?: boolean };

export type RenewGoalMutationVariables = Exact<{
  goalId: Scalars['Int']['input'];
  childId: Scalars['Int']['input'];
  newExpirationDate: Scalars['String']['input'];
}>;


export type RenewGoalMutation = { renewGoal?: { id: number, expiresAt?: string } };

export type FinalizeGoalMutationVariables = Exact<{
  goalId: Scalars['Int']['input'];
  childId: Scalars['Int']['input'];
}>;


export type FinalizeGoalMutation = { finalizeGoal?: { id: number, finalizedAt?: string } };

export type CompleteAndVerifyGoalMutationVariables = Exact<{
  goalId: Scalars['Int']['input'];
  childId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  achievedDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompleteAndVerifyGoalMutation = { completeAndVerifyGoal?: { id: number } };

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  primaryTherapistId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InviteUserMutation = { therapistInviteUser: number };

export type ResendInviteMutationVariables = Exact<{
  inviteId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendInviteMutation = { therapistResendInviteUser?: boolean };

export type DeleteInviteMutationVariables = Exact<{
  inviteId: Scalars['Int']['input'];
}>;


export type DeleteInviteMutation = { therapistDeleteInviteUser?: boolean };

export type GetTherapistInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistInvitesQuery = { therapistInvites?: Array<{ inviteId: number, email: string, accountType: AccountType, clientName: string }> };

export type StorePendingInviteGoalsMutationVariables = Exact<{
  inviteId: Scalars['Int']['input'];
  goals?: InputMaybe<Array<InputMaybe<PendingGoal>> | InputMaybe<PendingGoal>>;
  timeZoneOffset: Scalars['String']['input'];
}>;


export type StorePendingInviteGoalsMutation = { storePendingInviteGoals?: boolean };

export type LinkExistingFamilyMutationVariables = Exact<{
  parentEmail: Scalars['String']['input'];
  language: Scalars['String']['input'];
  primaryTherapistId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LinkExistingFamilyMutation = { therapistLinkExistingFamily?: Array<{ id: number, firstName: string }> };

export type SendMessageMutationVariables = Exact<{
  options: SendMessageOptions;
}>;


export type SendMessageMutation = { sendMessage?: boolean };

export type GetConversationsQueryVariables = Exact<{
  options: ConversationQueryOptions;
}>;


export type GetConversationsQuery = { conversations: Array<{ id: number, read: boolean, recipientReadAt?: string, type: ConversationType, familyId?: number, archivedAt?: string, permissions: Array<ConversationPermission>, users: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType, familyId: number }>, messages: Array<{ id: number, message: string, date: string, automated?: boolean, hasAttachments?: boolean, from: { id: number, firstName: string, lastName?: string } }>, pendingActions?: Array<{ id: number, reason: PendingActionType }> }> };

export type GetMessageAttachmentsQueryVariables = Exact<{
  messageId: Scalars['Int']['input'];
  includeData?: InputMaybe<Scalars['Boolean']['input']>;
  asUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMessageAttachmentsQuery = { messageAttachments?: Array<{ name: string, mimeType: string, base64?: string }> };

export type MarkConversationReadMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type MarkConversationReadMutation = { markConversationRead?: boolean };

export type GetTherapistChildParentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistChildParentsQuery = { therapistChildParents?: Array<{ adultId?: number, childId?: number }> };

export type GetTherapistCareTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistCareTeamQuery = { careTeam?: { careCoordinationEnabled: boolean, users?: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType, email?: string, ehrUserId?: string, credentialing?: string, licensedStates?: Array<string>, profileImageUrl?: string, createdAt?: string, lastActiveAt?: string }> } };

export type SendMessageBatchMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<ConversationOptions>> | InputMaybe<ConversationOptions>>;
}>;


export type SendMessageBatchMutation = { sendMessageBatch?: boolean };

export type GetActivityFeedQueryVariables = Exact<{
  userIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetActivityFeedQuery = { activityFeed?: Array<{ date: string, title: string, subtitle?: string, icon?: string, image?: string }> };

export type CreateConversationMutationVariables = Exact<{
  userIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateConversationMutation = { createConversation?: number };

export type AddConnectionToCareTeamMemberMutationVariables = Exact<{
  connectUserEmail: Scalars['String']['input'];
  connectToCareMemberUserId: Scalars['Int']['input'];
}>;


export type AddConnectionToCareTeamMemberMutation = { addConnectionToCareTeamMember?: { status: number, message?: string } };

export type DeletePendingActionsMutationVariables = Exact<{
  conversationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DeletePendingActionsMutation = { deletePendingActions?: boolean };

export type GetFamiliesQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFamiliesQuery = { families?: Array<{ id: number, users?: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType, email?: string, phoneNumber?: string, dateOfBirth?: string, ehrUserId?: string, groupName?: string, providerName?: string }> }> };

export type LeaveConversationMutationVariables = Exact<{
  conversationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeaveConversationMutation = { leaveConversation?: boolean };

export type GetUnreadConversationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadConversationCountQuery = { unreadConversationCount: number };

export type GetChildrenByParentEmailQueryVariables = Exact<{
  parentEmail: Scalars['String']['input'];
}>;


export type GetChildrenByParentEmailQuery = { childrenByParentEmail?: Array<{ id: number, firstName: string, lastName?: string, therapists?: Array<{ user: { id: number, firstName: string, lastName?: string } }>, parentCoaches?: Array<{ user: { id: number, firstName: string, lastName?: string } }>, careCoordinators?: Array<{ user: { id: number, firstName: string, lastName?: string } }> }> };

export type RemoveConnectionToCareTeamMemberMutationVariables = Exact<{
  disconnectCareMemberUserId?: InputMaybe<Scalars['Int']['input']>;
  disconnectAllCareTeamMembers?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectUserId: Scalars['Int']['input'];
}>;


export type RemoveConnectionToCareTeamMemberMutation = { removeConnectionToCareTeamMember?: boolean };

export type DeleteMessageMutationVariables = Exact<{
  messageId: Scalars['Int']['input'];
}>;


export type DeleteMessageMutation = { deleteMessage?: boolean };

export type CreateAppointmentMutationVariables = Exact<{
  appointmentTypeId: Scalars['String']['input'];
  attendeeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  date: Scalars['String']['input'];
  contactMethod: Scalars['String']['input'];
}>;


export type CreateAppointmentMutation = { createAppointment: { id: string, date: string, length: number, contactMethod: string, attendees: Array<{ id: number, firstName: string, lastName?: string, familyId: number, accountType: AccountType }>, appointmentType: { id: string, name: string } } };

export type GetAppointmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentTypesQuery = { appointmentTypes: Array<{ id: string, name: string, length: number, isGroup: boolean, contactMethods: Array<string>, applicableCareTeamMemberIds: Array<number>, pricingInfo?: { priceInCents?: number } }> };

export type GetAvailableDaysQueryVariables = Exact<{
  dateInMonth: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  appointmentTypeId: Scalars['String']['input'];
  contactMethod: Scalars['String']['input'];
  recurringInterval?: InputMaybe<RecurringAppointmentInterval>;
  recurringCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAvailableDaysQuery = { availableDays?: { availableDates?: Array<string> } };

export type GetAvailableTimeSlotsQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  appointmentTypeId: Scalars['String']['input'];
  contactMethod: Scalars['String']['input'];
  recurringInterval?: InputMaybe<RecurringAppointmentInterval>;
  recurringCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAvailableTimeSlotsQuery = { availableTimeSlots?: Array<{ userId: number, startTime: string }> };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { me: { id: number, accountType: AccountType, firstName: string, lastName?: string, email?: string, providerName?: string, ehrUserId?: string } };

export type GetFamilyMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFamilyMembersQuery = { me: { id: number, accountType: AccountType, firstName: string, lastName?: string, email?: string, dateOfBirth?: string }, familyMembers?: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType, dateOfBirth?: string }> };

export type GetFormsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<FormStatus>;
}>;


export type GetFormsQuery = { forms: Array<{ id: string, status: FormStatus, user: { id: number, firstName: string }, formTemplate: { id: string, name: string } }> };

export type CreateEhrApiKeysMutationVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateEhrApiKeysMutation = { createEhrApiKeys?: Array<{ apiKey?: string, userId?: number, ehrUserId?: string }> };

export type GetGuidingStarsQueryVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetGuidingStarsQuery = { guidingStars: Array<{ id: number, userId: number, description: string }> };

export type GetCareTeamMemberMatchesQueryVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCareTeamMemberMatchesQuery = { careTeamMemberMatches: Array<{ user: { id: number, firstName: string, lastName?: string, accountType: AccountType, familyId: number }, careTeamMember: { id: number, firstName: string, lastName?: string, accountType: AccountType, credentialing?: string, profileImageUrl?: string } }> };

export type GetFamilyMemberCareTeamMatchesQueryVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetFamilyMemberCareTeamMatchesQuery = { familyMembers?: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType }>, careTeamMemberMatches: Array<{ user: { id: number, firstName: string, lastName?: string, accountType: AccountType, familyId: number }, careTeamMember: { id: number, firstName: string, lastName?: string, accountType: AccountType, credentialing?: string, profileImageUrl?: string } }> };

export type GetCareScreenersQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  filterByLatest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCareScreenersQuery = { careScreeners: Array<{ id: number, typeformId: string, typeformResponseId: string, path: string, email: string, phoneNumber: string, schedulingQueryStartDate?: string, createdAt: string }> };

export type SendCareTeamMemberMatchesEmailMutationVariables = Exact<{
  contextUserId: Scalars['Int']['input'];
  emailRecipientUserIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SendCareTeamMemberMatchesEmailMutation = { sendCareTeamMemberMatchesEmail: { operationName?: string, errors?: Array<string>, mutatedObjects?: Array<{ id?: string, data?: string }> } };

export type SetCareTeamMemberMatchesMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  careTeamMemberIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  retainCareCoordinatorMatches?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetCareTeamMemberMatchesMutation = { setCareTeamMemberMatches: Array<{ user: { id: number, firstName: string, lastName?: string, accountType: AccountType, familyId: number }, careTeamMember: { id: number, firstName: string, lastName?: string, accountType: AccountType } }> };

export type CreateInsuranceCardMutationVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  frontImage: FileInput;
  backImage: FileInput;
}>;


export type CreateInsuranceCardMutation = { createInsuranceCard: { id: number, userIds: Array<number>, createdByUserId: number, createdAt: string, frontImage: { name: string, mimeType: string, path?: string }, backImage: { name: string, mimeType: string, path?: string } } };

export type SearchExternalOrganizationsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchExternalOrganizationsQuery = { searchExternalOrganizations: Array<{ id: number, name: string }> };

export type GetExternalOrganizationsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetExternalOrganizationsQuery = { externalOrganizations: Array<{ id: number, name: string }> };

export type SearchExternalProvidersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  externalOrganizationId: Scalars['Int']['input'];
}>;


export type SearchExternalProvidersQuery = { searchExternalProviders: Array<{ id: number, contact: { firstName?: string, lastName?: string, fullName?: string } }> };

export type CreateExternalOrganizationMutationVariables = Exact<{
  input: CreateExternalOrganizationInput;
}>;


export type CreateExternalOrganizationMutation = { createExternalOrganization: { id: number, name: string } };

export type CreateExternalProviderMutationVariables = Exact<{
  input: CreateExternalProviderInput;
}>;


export type CreateExternalProviderMutation = { createExternalProvider: { id: number, contact: { firstName?: string, lastName?: string, fullName?: string } } };

export type UpdateExternalProviderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateExternalProviderInput;
}>;


export type UpdateExternalProviderMutation = { updateExternalProvider: { id: number, receiveUpdates?: boolean } };

export type GetReferralsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  externalProviderIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetReferralsQuery = { referrals: Array<{ id: number, createdAt: string, note?: string, status?: string, externalOrganizationId?: number, externalProvider?: { id: number, contact: { firstName?: string, lastName?: string, fullName?: string, email?: string, phoneNumber?: string, faxNumber?: string, businessName?: string } }, externalOrganization?: { id: number, name: string, stateCode?: string, partnerType?: ExternalOrganizationPartnerType, utmSource?: string, utmMedium?: string, utmCampaign?: string }, referredClients: Array<{ id: number, type: ReferredClientType, isCareRecipient: boolean, serviceLine?: string, createdAt: string, updatedAt: string, contact: { firstName?: string, lastName?: string, fullName?: string, email?: string, phoneNumber?: string, dob?: string } }> }> };

export type GetClientExternalPreviewsQueryVariables = Exact<{
  externalProviderIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetClientExternalPreviewsQuery = { clientExternalPreviews: Array<{ firstName?: string, lastName?: string, dateAdded?: string, status?: string, details?: string, hasProgressSummary: boolean, progressSummaryUserId?: number }> };

export type GetReferringProviderStatsQueryVariables = Exact<{
  externalProviderId: Scalars['Int']['input'];
}>;


export type GetReferringProviderStatsQuery = { referringProviderStats: { referralsMade: number, therapySessionsCompleted: number } };

export type GetClientProgressSummaryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetClientProgressSummaryQuery = { clientProgressSummary?: { summaryDate?: string, intakeDate?: string, intakeConcerns?: string, clientDob?: string, referringProvider?: string, diagnosis?: string, childGoals?: string, familyGoals?: string, sessionsCompleted?: string, sessionsShowRate?: string } };

export type CreateReferralMutationVariables = Exact<{
  input: CreateReferralInput;
}>;


export type CreateReferralMutation = { createReferral: { id: number } };

export type GetExternalProvidersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExternalProvidersQuery = { getExternalProviders: Array<{ id: number, externalOrganizationId?: number, receiveUpdates?: boolean, createdAt: string, updatedAt: string, contact: { firstName?: string, lastName?: string, fullName?: string, email?: string, phoneNumber?: string, businessName?: string }, externalOrganization?: { id: number, name: string, stateCode?: string, partnerType?: ExternalOrganizationPartnerType, canReceiveUpdates: boolean } }> };

export type GetExternalOrganizationsListQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExternalOrganizationsListQuery = { externalOrganizations: Array<{ id: number, name: string, stateCode?: string, partnerType?: ExternalOrganizationPartnerType, canReceiveUpdates: boolean, createdAt: string, updatedAt: string }> };

export type SearchUsersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchUsersQuery = { users: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType, email?: string, phoneNumber?: string, dateOfBirth?: string, ehrUserId?: string, groupName?: string, familyId: number, providerName?: string }> };

export type SearchCareScreenersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchCareScreenersQuery = { careScreeners: Array<{ id: number, email: string, phoneNumber: string, path: string, consultStatus?: string, directIntakeStatus?: string, createdAt: string, userId?: number, user?: { id: number, firstName: string, lastName?: string } }> };

export type SearchEhrUsersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchEhrUsersQuery = { ehrUsers: Array<{ id?: string, manateeUserId?: string, active?: boolean, firstName?: string, lastName?: string, email?: string, phoneNumber?: string, groupName?: string }> };

export type SearchReferralsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchReferralsQuery = { referrals: Array<{ id: number, status?: string, createdAt: string, externalProvider?: { id: number, contact: { firstName?: string, lastName?: string, fullName?: string, email?: string, phoneNumber?: string, businessName?: string } }, referredClients: Array<{ id: number, type: ReferredClientType, userId?: number, isCareRecipient: boolean, contact: { firstName?: string, lastName?: string, fullName?: string, email?: string, phoneNumber?: string } }> }> };

export type CreateOneTimeAuthLinkMutationVariables = Exact<{
  externalProviderId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOneTimeAuthLinkMutation = { createOneTimeAuthLink: { link?: string, message: string, success: boolean } };

export type GetAppointmentsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetAppointmentsQuery = { appointments?: Array<{ id: string, date: string, length: number, contactMethod: string, telehealthJoinUrl?: string, pmStatus?: string, attendees: Array<{ id: number, firstName: string, lastName?: string, accountType: AccountType }>, appointmentType: { id: string, name: string } }> };

export type GetExternalOrganizationStatsQueryVariables = Exact<{
  providerLimit?: InputMaybe<Scalars['Int']['input']>;
  providerOffset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExternalOrganizationStatsQuery = { externalOrganizations: Array<{ id: number, name: string, totalProviderCount?: number, currentProviderId?: number, clientStats?: Array<{ timeframe: TimeFilter, referredClientCount: number, activeClientCount: number, totalClientCount: number }>, providers?: Array<{ id: number, lastReferralDate?: string, contact: { fullName?: string }, clientStats?: Array<{ timeframe: TimeFilter, referredClientCount: number, activeClientCount: number, totalClientCount: number }> }> }> };

export type GetAuthenticatedProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatedProviderQuery = { externalOrganizations: Array<{ id: number, name: string, currentProviderId?: number, totalProviderCount?: number, providers?: Array<{ id: number, contact: { firstName?: string, lastName?: string, fullName?: string } }> }> };


export const GetHomeDocument = gql`
    query getHome {
  me {
    id
    accountType
    firstName
    lastName
    providerName
  }
  assessments(options: {includeArchived: true}) {
    identifier
    name
    type
    isArchived
    categoryCriteria {
      order
      category
      clinicalCategory
      minScore
      maxScore
      color
    }
    subAssessments {
      identifier
      name
      type
      isArchived
      categoryCriteria {
        order
        category
        clinicalCategory
        minScore
        maxScore
        color
      }
    }
  }
  canReceiveMessages {
    canReceiveMessages
  }
  messageTemplates {
    id
    key
    name
    category
    message
  }
}
    `;

/**
 * __useGetHomeQuery__
 *
 * To run a query within a React component, call `useGetHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeQuery(baseOptions?: Apollo.QueryHookOptions<GetHomeQuery, GetHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, options);
      }
export function useGetHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeQuery, GetHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, options);
        }
export function useGetHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeQuery, GetHomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, options);
        }
export type GetHomeQueryHookResult = ReturnType<typeof useGetHomeQuery>;
export type GetHomeLazyQueryHookResult = ReturnType<typeof useGetHomeLazyQuery>;
export type GetHomeSuspenseQueryHookResult = ReturnType<typeof useGetHomeSuspenseQuery>;
export type GetHomeQueryResult = Apollo.QueryResult<GetHomeQuery, GetHomeQueryVariables>;
export const GetChildrenDocument = gql`
    query getChildren($excludeArchived: Boolean) {
  me {
    children(excludeArchived: $excludeArchived) {
      user {
        id
        accountType
        firstName
        lastName
        dateOfBirth
        pointsBalance
        createdAt
        username
        email
        lastActiveAt
        timeZone
        familyId
        ehrUserId
        activeClient
        groupName
        parents {
          user {
            id
            firstName
            lastName
            activeClient
            groupName
            ehrUserId
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetChildrenQuery__
 *
 * To run a query within a React component, call `useGetChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenQuery({
 *   variables: {
 *      excludeArchived: // value for 'excludeArchived'
 *   },
 * });
 */
export function useGetChildrenQuery(baseOptions?: Apollo.QueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, options);
      }
export function useGetChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, options);
        }
export function useGetChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, options);
        }
export type GetChildrenQueryHookResult = ReturnType<typeof useGetChildrenQuery>;
export type GetChildrenLazyQueryHookResult = ReturnType<typeof useGetChildrenLazyQuery>;
export type GetChildrenSuspenseQueryHookResult = ReturnType<typeof useGetChildrenSuspenseQuery>;
export type GetChildrenQueryResult = Apollo.QueryResult<GetChildrenQuery, GetChildrenQueryVariables>;
export const GetTherapistCustomGoalsDocument = gql`
    query getTherapistCustomGoals {
  therapistCustomGoals {
    id
    name
    value
    imageId
  }
}
    `;

/**
 * __useGetTherapistCustomGoalsQuery__
 *
 * To run a query within a React component, call `useGetTherapistCustomGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistCustomGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistCustomGoalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTherapistCustomGoalsQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>(GetTherapistCustomGoalsDocument, options);
      }
export function useGetTherapistCustomGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>(GetTherapistCustomGoalsDocument, options);
        }
export function useGetTherapistCustomGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>(GetTherapistCustomGoalsDocument, options);
        }
export type GetTherapistCustomGoalsQueryHookResult = ReturnType<typeof useGetTherapistCustomGoalsQuery>;
export type GetTherapistCustomGoalsLazyQueryHookResult = ReturnType<typeof useGetTherapistCustomGoalsLazyQuery>;
export type GetTherapistCustomGoalsSuspenseQueryHookResult = ReturnType<typeof useGetTherapistCustomGoalsSuspenseQuery>;
export type GetTherapistCustomGoalsQueryResult = Apollo.QueryResult<GetTherapistCustomGoalsQuery, GetTherapistCustomGoalsQueryVariables>;
export const GetTherapistCustomParentGoalsDocument = gql`
    query getTherapistCustomParentGoals {
  goals(options: {includeAssignable: true, assigneeTypes: ["PARENT"]}) {
    id
    name
    description
    dueAt
    assignedAt
    reminderTime1
    reminderTime2
  }
}
    `;

/**
 * __useGetTherapistCustomParentGoalsQuery__
 *
 * To run a query within a React component, call `useGetTherapistCustomParentGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistCustomParentGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistCustomParentGoalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTherapistCustomParentGoalsQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>(GetTherapistCustomParentGoalsDocument, options);
      }
export function useGetTherapistCustomParentGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>(GetTherapistCustomParentGoalsDocument, options);
        }
export function useGetTherapistCustomParentGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>(GetTherapistCustomParentGoalsDocument, options);
        }
export type GetTherapistCustomParentGoalsQueryHookResult = ReturnType<typeof useGetTherapistCustomParentGoalsQuery>;
export type GetTherapistCustomParentGoalsLazyQueryHookResult = ReturnType<typeof useGetTherapistCustomParentGoalsLazyQuery>;
export type GetTherapistCustomParentGoalsSuspenseQueryHookResult = ReturnType<typeof useGetTherapistCustomParentGoalsSuspenseQuery>;
export type GetTherapistCustomParentGoalsQueryResult = Apollo.QueryResult<GetTherapistCustomParentGoalsQuery, GetTherapistCustomParentGoalsQueryVariables>;
export const GetChildMoodDocument = gql`
    query getChildMood($childId: Int!, $daysBack: Int) {
  childMood(childId: $childId, daysBack: $daysBack) {
    sadCount
    neutralCount
    happyCount
  }
}
    `;

/**
 * __useGetChildMoodQuery__
 *
 * To run a query within a React component, call `useGetChildMoodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildMoodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildMoodQuery({
 *   variables: {
 *      childId: // value for 'childId'
 *      daysBack: // value for 'daysBack'
 *   },
 * });
 */
export function useGetChildMoodQuery(baseOptions: Apollo.QueryHookOptions<GetChildMoodQuery, GetChildMoodQueryVariables> & ({ variables: GetChildMoodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildMoodQuery, GetChildMoodQueryVariables>(GetChildMoodDocument, options);
      }
export function useGetChildMoodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildMoodQuery, GetChildMoodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildMoodQuery, GetChildMoodQueryVariables>(GetChildMoodDocument, options);
        }
export function useGetChildMoodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildMoodQuery, GetChildMoodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildMoodQuery, GetChildMoodQueryVariables>(GetChildMoodDocument, options);
        }
export type GetChildMoodQueryHookResult = ReturnType<typeof useGetChildMoodQuery>;
export type GetChildMoodLazyQueryHookResult = ReturnType<typeof useGetChildMoodLazyQuery>;
export type GetChildMoodSuspenseQueryHookResult = ReturnType<typeof useGetChildMoodSuspenseQuery>;
export type GetChildMoodQueryResult = Apollo.QueryResult<GetChildMoodQuery, GetChildMoodQueryVariables>;
export const GetChildDetailsDocument = gql`
    query getChildDetails($childId: Int!) {
  childDetails(childId: $childId) {
    id
    accountType
    firstName
    lastName
    lifetimePoints
    createdAt
    therapists {
      user {
        id
      }
    }
  }
  childParents(childId: $childId) {
    id
    firstName
    lastName
    email
    phoneNumber
    createdAt
    lastActiveAt
    timeZone
    accountType
    ehrUserId
    goals {
      id
      name
      description
      dueAt
      assignedAt
      reminderTime1
      reminderTime2
      achievements(options: {excludePending: true}) {
        id
        achievedAt
      }
    }
    achievements(options: {excludePending: true}) {
      id
      achievedAt
      goalFeedback
      feelingDuringCompletion
      feedbackText
      goal {
        id
        name
      }
    }
  }
  childGoals(childId: $childId, options: {includeFinalized: true}) {
    id
    name
    dueAt
    dailyFrequency
    expiresAt
    finalizedAt
    value
    assignedAt
    assignerType
    reminderTime1
    achievements(childId: $childId, options: {excludePending: true}) {
      id
      achievedAt
      points
      image
    }
  }
  achievements(childId: $childId, options: {excludePending: true}) {
    id
    achievedAt
    points
    goalFeedback
    feelingDuringCompletion
    feedbackText
    goal {
      id
      name
      dueAt
      assignedAt
      expiresAt
    }
  }
  rewards(childId: $childId) {
    id
    name
    redemptions {
      approvedBy {
        id
      }
      redeemedAt
      cost
    }
  }
}
    `;

/**
 * __useGetChildDetailsQuery__
 *
 * To run a query within a React component, call `useGetChildDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildDetailsQuery({
 *   variables: {
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useGetChildDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetChildDetailsQuery, GetChildDetailsQueryVariables> & ({ variables: GetChildDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildDetailsQuery, GetChildDetailsQueryVariables>(GetChildDetailsDocument, options);
      }
export function useGetChildDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildDetailsQuery, GetChildDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildDetailsQuery, GetChildDetailsQueryVariables>(GetChildDetailsDocument, options);
        }
export function useGetChildDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildDetailsQuery, GetChildDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildDetailsQuery, GetChildDetailsQueryVariables>(GetChildDetailsDocument, options);
        }
export type GetChildDetailsQueryHookResult = ReturnType<typeof useGetChildDetailsQuery>;
export type GetChildDetailsLazyQueryHookResult = ReturnType<typeof useGetChildDetailsLazyQuery>;
export type GetChildDetailsSuspenseQueryHookResult = ReturnType<typeof useGetChildDetailsSuspenseQuery>;
export type GetChildDetailsQueryResult = Apollo.QueryResult<GetChildDetailsQuery, GetChildDetailsQueryVariables>;
export const GetAssessmentAssignmentsAndCompletionsDocument = gql`
    query getAssessmentAssignmentsAndCompletions($userIds: [Int], $assessmentIdentifiers: [String]) {
  assessmentsAssignable(userIds: $userIds) {
    assessmentIdentifiers
    assignable
    userAssessments {
      userId
      assessmentIdentifiers
    }
  }
  assessmentAssignments(assigneeIds: $userIds) {
    assigneeId
    assessmentIdentifier
    assessmentParameters {
      subjectUserId
    }
  }
  completedAssessments(
    options: {userIds: $userIds, assessmentIdentifiers: $assessmentIdentifiers}
  ) {
    id
    clientId
    assessmentIdentifier
    category
    score
    scorePossible
    completedAt
    name
    isArchived
    answers {
      questionId
      choiceId
      questionText
      choiceText
      responseText
    }
    assessmentParameters {
      subjectUserId
    }
    subResponses {
      id
      clientId
      assessmentIdentifier
      category
      score
      scorePossible
      completedAt
      name
      isArchived
      answers {
        questionId
        choiceId
        questionText
        choiceText
      }
      assessmentParameters {
        subjectUserId
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentAssignmentsAndCompletionsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentAssignmentsAndCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentAssignmentsAndCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentAssignmentsAndCompletionsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      assessmentIdentifiers: // value for 'assessmentIdentifiers'
 *   },
 * });
 */
export function useGetAssessmentAssignmentsAndCompletionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>(GetAssessmentAssignmentsAndCompletionsDocument, options);
      }
export function useGetAssessmentAssignmentsAndCompletionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>(GetAssessmentAssignmentsAndCompletionsDocument, options);
        }
export function useGetAssessmentAssignmentsAndCompletionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>(GetAssessmentAssignmentsAndCompletionsDocument, options);
        }
export type GetAssessmentAssignmentsAndCompletionsQueryHookResult = ReturnType<typeof useGetAssessmentAssignmentsAndCompletionsQuery>;
export type GetAssessmentAssignmentsAndCompletionsLazyQueryHookResult = ReturnType<typeof useGetAssessmentAssignmentsAndCompletionsLazyQuery>;
export type GetAssessmentAssignmentsAndCompletionsSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentAssignmentsAndCompletionsSuspenseQuery>;
export type GetAssessmentAssignmentsAndCompletionsQueryResult = Apollo.QueryResult<GetAssessmentAssignmentsAndCompletionsQuery, GetAssessmentAssignmentsAndCompletionsQueryVariables>;
export const AssignAssessmentsDocument = gql`
    mutation assignAssessments($assignments: [AssessmentAssignmentRequest!]) {
  assignAssessments(assignments: $assignments) {
    assigneeId
  }
}
    `;
export type AssignAssessmentsMutationFn = Apollo.MutationFunction<AssignAssessmentsMutation, AssignAssessmentsMutationVariables>;

/**
 * __useAssignAssessmentsMutation__
 *
 * To run a mutation, you first call `useAssignAssessmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAssessmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAssessmentsMutation, { data, loading, error }] = useAssignAssessmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useAssignAssessmentsMutation(baseOptions?: Apollo.MutationHookOptions<AssignAssessmentsMutation, AssignAssessmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAssessmentsMutation, AssignAssessmentsMutationVariables>(AssignAssessmentsDocument, options);
      }
export type AssignAssessmentsMutationHookResult = ReturnType<typeof useAssignAssessmentsMutation>;
export type AssignAssessmentsMutationResult = Apollo.MutationResult<AssignAssessmentsMutation>;
export type AssignAssessmentsMutationOptions = Apollo.BaseMutationOptions<AssignAssessmentsMutation, AssignAssessmentsMutationVariables>;
export const GetAdultRewardsDocument = gql`
    query getAdultRewards($childId: Int!) {
  childDetails(childId: $childId) {
    id
    firstName
  }
  rewards(childId: $childId) {
    id
    name
    description
    imageId
    cost
    assignedTo {
      id
    }
  }
}
    `;

/**
 * __useGetAdultRewardsQuery__
 *
 * To run a query within a React component, call `useGetAdultRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdultRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdultRewardsQuery({
 *   variables: {
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useGetAdultRewardsQuery(baseOptions: Apollo.QueryHookOptions<GetAdultRewardsQuery, GetAdultRewardsQueryVariables> & ({ variables: GetAdultRewardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdultRewardsQuery, GetAdultRewardsQueryVariables>(GetAdultRewardsDocument, options);
      }
export function useGetAdultRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdultRewardsQuery, GetAdultRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdultRewardsQuery, GetAdultRewardsQueryVariables>(GetAdultRewardsDocument, options);
        }
export function useGetAdultRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdultRewardsQuery, GetAdultRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdultRewardsQuery, GetAdultRewardsQueryVariables>(GetAdultRewardsDocument, options);
        }
export type GetAdultRewardsQueryHookResult = ReturnType<typeof useGetAdultRewardsQuery>;
export type GetAdultRewardsLazyQueryHookResult = ReturnType<typeof useGetAdultRewardsLazyQuery>;
export type GetAdultRewardsSuspenseQueryHookResult = ReturnType<typeof useGetAdultRewardsSuspenseQuery>;
export type GetAdultRewardsQueryResult = Apollo.QueryResult<GetAdultRewardsQuery, GetAdultRewardsQueryVariables>;
export const GetAdultGoalsDocument = gql`
    query getAdultGoals($childId: Int!) {
  childDetails(childId: $childId) {
    id
    accountType
    firstName
    theme
  }
  adultGoals(childId: $childId) {
    id
    name
    description
    dueAt
    dailyFrequency
    reminderTime1
    reminderTime2
    expiresAt
    value
    imageId
    assignedTo {
      id
    }
    readOnly
    assignerType
  }
}
    `;

/**
 * __useGetAdultGoalsQuery__
 *
 * To run a query within a React component, call `useGetAdultGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdultGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdultGoalsQuery({
 *   variables: {
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useGetAdultGoalsQuery(baseOptions: Apollo.QueryHookOptions<GetAdultGoalsQuery, GetAdultGoalsQueryVariables> & ({ variables: GetAdultGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdultGoalsQuery, GetAdultGoalsQueryVariables>(GetAdultGoalsDocument, options);
      }
export function useGetAdultGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdultGoalsQuery, GetAdultGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdultGoalsQuery, GetAdultGoalsQueryVariables>(GetAdultGoalsDocument, options);
        }
export function useGetAdultGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdultGoalsQuery, GetAdultGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdultGoalsQuery, GetAdultGoalsQueryVariables>(GetAdultGoalsDocument, options);
        }
export type GetAdultGoalsQueryHookResult = ReturnType<typeof useGetAdultGoalsQuery>;
export type GetAdultGoalsLazyQueryHookResult = ReturnType<typeof useGetAdultGoalsLazyQuery>;
export type GetAdultGoalsSuspenseQueryHookResult = ReturnType<typeof useGetAdultGoalsSuspenseQuery>;
export type GetAdultGoalsQueryResult = Apollo.QueryResult<GetAdultGoalsQuery, GetAdultGoalsQueryVariables>;
export const GetGoalAchievementImageDocument = gql`
    query getGoalAchievementImage($assigneeId: Int!, $goalId: Int!, $achievementId: Int!) {
  achievementImage(
    assigneeId: $assigneeId
    goalId: $goalId
    achievementId: $achievementId
  ) {
    image
  }
}
    `;

/**
 * __useGetGoalAchievementImageQuery__
 *
 * To run a query within a React component, call `useGetGoalAchievementImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoalAchievementImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoalAchievementImageQuery({
 *   variables: {
 *      assigneeId: // value for 'assigneeId'
 *      goalId: // value for 'goalId'
 *      achievementId: // value for 'achievementId'
 *   },
 * });
 */
export function useGetGoalAchievementImageQuery(baseOptions: Apollo.QueryHookOptions<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables> & ({ variables: GetGoalAchievementImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables>(GetGoalAchievementImageDocument, options);
      }
export function useGetGoalAchievementImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables>(GetGoalAchievementImageDocument, options);
        }
export function useGetGoalAchievementImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables>(GetGoalAchievementImageDocument, options);
        }
export type GetGoalAchievementImageQueryHookResult = ReturnType<typeof useGetGoalAchievementImageQuery>;
export type GetGoalAchievementImageLazyQueryHookResult = ReturnType<typeof useGetGoalAchievementImageLazyQuery>;
export type GetGoalAchievementImageSuspenseQueryHookResult = ReturnType<typeof useGetGoalAchievementImageSuspenseQuery>;
export type GetGoalAchievementImageQueryResult = Apollo.QueryResult<GetGoalAchievementImageQuery, GetGoalAchievementImageQueryVariables>;
export const CreateGoalDocument = gql`
    mutation createGoal($assignedTo: Int!, $name: String!, $description: String, $dueAt: String!, $dailyFrequency: Int, $reminderTime1: String, $reminderTime2: String, $expiresAt: String!, $value: Int!, $imageId: Int!, $createUnassignedCopy: Boolean, $unassignedCopyReminderTime1: String, $unassignedCopyReminderTime2: String) {
  createGoal(
    name: $name
    description: $description
    dueAt: $dueAt
    dailyFrequency: $dailyFrequency
    reminderTime1: $reminderTime1
    reminderTime2: $reminderTime2
    expiresAt: $expiresAt
    assignedTo: $assignedTo
    value: $value
    imageId: $imageId
    createUnassignedCopy: $createUnassignedCopy
    unassignedCopyReminderTime1: $unassignedCopyReminderTime1
    unassignedCopyReminderTime2: $unassignedCopyReminderTime2
  ) {
    id
  }
}
    `;
export type CreateGoalMutationFn = Apollo.MutationFunction<CreateGoalMutation, CreateGoalMutationVariables>;

/**
 * __useCreateGoalMutation__
 *
 * To run a mutation, you first call `useCreateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalMutation, { data, loading, error }] = useCreateGoalMutation({
 *   variables: {
 *      assignedTo: // value for 'assignedTo'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      dueAt: // value for 'dueAt'
 *      dailyFrequency: // value for 'dailyFrequency'
 *      reminderTime1: // value for 'reminderTime1'
 *      reminderTime2: // value for 'reminderTime2'
 *      expiresAt: // value for 'expiresAt'
 *      value: // value for 'value'
 *      imageId: // value for 'imageId'
 *      createUnassignedCopy: // value for 'createUnassignedCopy'
 *      unassignedCopyReminderTime1: // value for 'unassignedCopyReminderTime1'
 *      unassignedCopyReminderTime2: // value for 'unassignedCopyReminderTime2'
 *   },
 * });
 */
export function useCreateGoalMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalMutation, CreateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalMutation, CreateGoalMutationVariables>(CreateGoalDocument, options);
      }
export type CreateGoalMutationHookResult = ReturnType<typeof useCreateGoalMutation>;
export type CreateGoalMutationResult = Apollo.MutationResult<CreateGoalMutation>;
export type CreateGoalMutationOptions = Apollo.BaseMutationOptions<CreateGoalMutation, CreateGoalMutationVariables>;
export const UpdateGoalDocument = gql`
    mutation updateGoal($goalId: Int!, $name: String!, $description: String, $dueAt: String!, $dailyFrequency: Int, $reminderTime1: String, $reminderTime2: String, $value: Int!, $imageId: Int!) {
  updateGoal(
    goalId: $goalId
    name: $name
    description: $description
    dueAt: $dueAt
    dailyFrequency: $dailyFrequency
    reminderTime1: $reminderTime1
    reminderTime2: $reminderTime2
    value: $value
    imageId: $imageId
  ) {
    id
  }
}
    `;
export type UpdateGoalMutationFn = Apollo.MutationFunction<UpdateGoalMutation, UpdateGoalMutationVariables>;

/**
 * __useUpdateGoalMutation__
 *
 * To run a mutation, you first call `useUpdateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalMutation, { data, loading, error }] = useUpdateGoalMutation({
 *   variables: {
 *      goalId: // value for 'goalId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      dueAt: // value for 'dueAt'
 *      dailyFrequency: // value for 'dailyFrequency'
 *      reminderTime1: // value for 'reminderTime1'
 *      reminderTime2: // value for 'reminderTime2'
 *      value: // value for 'value'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useUpdateGoalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalMutation, UpdateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalMutation, UpdateGoalMutationVariables>(UpdateGoalDocument, options);
      }
export type UpdateGoalMutationHookResult = ReturnType<typeof useUpdateGoalMutation>;
export type UpdateGoalMutationResult = Apollo.MutationResult<UpdateGoalMutation>;
export type UpdateGoalMutationOptions = Apollo.BaseMutationOptions<UpdateGoalMutation, UpdateGoalMutationVariables>;
export const DeleteGoalDocument = gql`
    mutation deleteGoal($goalId: Int!) {
  deleteGoal(goalId: $goalId)
}
    `;
export type DeleteGoalMutationFn = Apollo.MutationFunction<DeleteGoalMutation, DeleteGoalMutationVariables>;

/**
 * __useDeleteGoalMutation__
 *
 * To run a mutation, you first call `useDeleteGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoalMutation, { data, loading, error }] = useDeleteGoalMutation({
 *   variables: {
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useDeleteGoalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoalMutation, DeleteGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGoalMutation, DeleteGoalMutationVariables>(DeleteGoalDocument, options);
      }
export type DeleteGoalMutationHookResult = ReturnType<typeof useDeleteGoalMutation>;
export type DeleteGoalMutationResult = Apollo.MutationResult<DeleteGoalMutation>;
export type DeleteGoalMutationOptions = Apollo.BaseMutationOptions<DeleteGoalMutation, DeleteGoalMutationVariables>;
export const RenewGoalDocument = gql`
    mutation renewGoal($goalId: Int!, $childId: Int!, $newExpirationDate: String!) {
  renewGoal(
    goalId: $goalId
    childId: $childId
    newExpirationDate: $newExpirationDate
  ) {
    id
    expiresAt
  }
}
    `;
export type RenewGoalMutationFn = Apollo.MutationFunction<RenewGoalMutation, RenewGoalMutationVariables>;

/**
 * __useRenewGoalMutation__
 *
 * To run a mutation, you first call `useRenewGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewGoalMutation, { data, loading, error }] = useRenewGoalMutation({
 *   variables: {
 *      goalId: // value for 'goalId'
 *      childId: // value for 'childId'
 *      newExpirationDate: // value for 'newExpirationDate'
 *   },
 * });
 */
export function useRenewGoalMutation(baseOptions?: Apollo.MutationHookOptions<RenewGoalMutation, RenewGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewGoalMutation, RenewGoalMutationVariables>(RenewGoalDocument, options);
      }
export type RenewGoalMutationHookResult = ReturnType<typeof useRenewGoalMutation>;
export type RenewGoalMutationResult = Apollo.MutationResult<RenewGoalMutation>;
export type RenewGoalMutationOptions = Apollo.BaseMutationOptions<RenewGoalMutation, RenewGoalMutationVariables>;
export const FinalizeGoalDocument = gql`
    mutation finalizeGoal($goalId: Int!, $childId: Int!) {
  finalizeGoal(childId: $childId, goalId: $goalId) {
    id
    finalizedAt
  }
}
    `;
export type FinalizeGoalMutationFn = Apollo.MutationFunction<FinalizeGoalMutation, FinalizeGoalMutationVariables>;

/**
 * __useFinalizeGoalMutation__
 *
 * To run a mutation, you first call `useFinalizeGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeGoalMutation, { data, loading, error }] = useFinalizeGoalMutation({
 *   variables: {
 *      goalId: // value for 'goalId'
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useFinalizeGoalMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeGoalMutation, FinalizeGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeGoalMutation, FinalizeGoalMutationVariables>(FinalizeGoalDocument, options);
      }
export type FinalizeGoalMutationHookResult = ReturnType<typeof useFinalizeGoalMutation>;
export type FinalizeGoalMutationResult = Apollo.MutationResult<FinalizeGoalMutation>;
export type FinalizeGoalMutationOptions = Apollo.BaseMutationOptions<FinalizeGoalMutation, FinalizeGoalMutationVariables>;
export const CompleteAndVerifyGoalDocument = gql`
    mutation completeAndVerifyGoal($goalId: Int!, $childId: Int!, $note: String, $achievedDate: String) {
  completeAndVerifyGoal(
    goalId: $goalId
    childId: $childId
    note: $note
    achievedDate: $achievedDate
  ) {
    id
  }
}
    `;
export type CompleteAndVerifyGoalMutationFn = Apollo.MutationFunction<CompleteAndVerifyGoalMutation, CompleteAndVerifyGoalMutationVariables>;

/**
 * __useCompleteAndVerifyGoalMutation__
 *
 * To run a mutation, you first call `useCompleteAndVerifyGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAndVerifyGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAndVerifyGoalMutation, { data, loading, error }] = useCompleteAndVerifyGoalMutation({
 *   variables: {
 *      goalId: // value for 'goalId'
 *      childId: // value for 'childId'
 *      note: // value for 'note'
 *      achievedDate: // value for 'achievedDate'
 *   },
 * });
 */
export function useCompleteAndVerifyGoalMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAndVerifyGoalMutation, CompleteAndVerifyGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAndVerifyGoalMutation, CompleteAndVerifyGoalMutationVariables>(CompleteAndVerifyGoalDocument, options);
      }
export type CompleteAndVerifyGoalMutationHookResult = ReturnType<typeof useCompleteAndVerifyGoalMutation>;
export type CompleteAndVerifyGoalMutationResult = Apollo.MutationResult<CompleteAndVerifyGoalMutation>;
export type CompleteAndVerifyGoalMutationOptions = Apollo.BaseMutationOptions<CompleteAndVerifyGoalMutation, CompleteAndVerifyGoalMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($email: String!, $note: String, $language: String!, $accountType: String!, $clientName: String!, $primaryTherapistId: Int) {
  therapistInviteUser(
    email: $email
    note: $note
    language: $language
    accountType: $accountType
    clientName: $clientName
    primaryTherapistId: $primaryTherapistId
  )
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      note: // value for 'note'
 *      language: // value for 'language'
 *      accountType: // value for 'accountType'
 *      clientName: // value for 'clientName'
 *      primaryTherapistId: // value for 'primaryTherapistId'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const ResendInviteDocument = gql`
    mutation resendInvite($inviteId: Int!, $note: String) {
  therapistResendInviteUser(inviteId: $inviteId, note: $note)
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const DeleteInviteDocument = gql`
    mutation deleteInvite($inviteId: Int!) {
  therapistDeleteInviteUser(inviteId: $inviteId)
}
    `;
export type DeleteInviteMutationFn = Apollo.MutationFunction<DeleteInviteMutation, DeleteInviteMutationVariables>;

/**
 * __useDeleteInviteMutation__
 *
 * To run a mutation, you first call `useDeleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInviteMutation, { data, loading, error }] = useDeleteInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeleteInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInviteMutation, DeleteInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInviteMutation, DeleteInviteMutationVariables>(DeleteInviteDocument, options);
      }
export type DeleteInviteMutationHookResult = ReturnType<typeof useDeleteInviteMutation>;
export type DeleteInviteMutationResult = Apollo.MutationResult<DeleteInviteMutation>;
export type DeleteInviteMutationOptions = Apollo.BaseMutationOptions<DeleteInviteMutation, DeleteInviteMutationVariables>;
export const GetTherapistInvitesDocument = gql`
    query getTherapistInvites {
  therapistInvites {
    inviteId
    email
    accountType
    clientName
  }
}
    `;

/**
 * __useGetTherapistInvitesQuery__
 *
 * To run a query within a React component, call `useGetTherapistInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTherapistInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>(GetTherapistInvitesDocument, options);
      }
export function useGetTherapistInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>(GetTherapistInvitesDocument, options);
        }
export function useGetTherapistInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>(GetTherapistInvitesDocument, options);
        }
export type GetTherapistInvitesQueryHookResult = ReturnType<typeof useGetTherapistInvitesQuery>;
export type GetTherapistInvitesLazyQueryHookResult = ReturnType<typeof useGetTherapistInvitesLazyQuery>;
export type GetTherapistInvitesSuspenseQueryHookResult = ReturnType<typeof useGetTherapistInvitesSuspenseQuery>;
export type GetTherapistInvitesQueryResult = Apollo.QueryResult<GetTherapistInvitesQuery, GetTherapistInvitesQueryVariables>;
export const StorePendingInviteGoalsDocument = gql`
    mutation storePendingInviteGoals($inviteId: Int!, $goals: [PendingGoal], $timeZoneOffset: String!) {
  storePendingInviteGoals(
    inviteId: $inviteId
    goals: $goals
    timeZoneOffset: $timeZoneOffset
  )
}
    `;
export type StorePendingInviteGoalsMutationFn = Apollo.MutationFunction<StorePendingInviteGoalsMutation, StorePendingInviteGoalsMutationVariables>;

/**
 * __useStorePendingInviteGoalsMutation__
 *
 * To run a mutation, you first call `useStorePendingInviteGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorePendingInviteGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storePendingInviteGoalsMutation, { data, loading, error }] = useStorePendingInviteGoalsMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      goals: // value for 'goals'
 *      timeZoneOffset: // value for 'timeZoneOffset'
 *   },
 * });
 */
export function useStorePendingInviteGoalsMutation(baseOptions?: Apollo.MutationHookOptions<StorePendingInviteGoalsMutation, StorePendingInviteGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorePendingInviteGoalsMutation, StorePendingInviteGoalsMutationVariables>(StorePendingInviteGoalsDocument, options);
      }
export type StorePendingInviteGoalsMutationHookResult = ReturnType<typeof useStorePendingInviteGoalsMutation>;
export type StorePendingInviteGoalsMutationResult = Apollo.MutationResult<StorePendingInviteGoalsMutation>;
export type StorePendingInviteGoalsMutationOptions = Apollo.BaseMutationOptions<StorePendingInviteGoalsMutation, StorePendingInviteGoalsMutationVariables>;
export const LinkExistingFamilyDocument = gql`
    mutation linkExistingFamily($parentEmail: String!, $language: String!, $primaryTherapistId: Int) {
  therapistLinkExistingFamily(
    parentEmail: $parentEmail
    language: $language
    primaryTherapistId: $primaryTherapistId
  ) {
    id
    firstName
  }
}
    `;
export type LinkExistingFamilyMutationFn = Apollo.MutationFunction<LinkExistingFamilyMutation, LinkExistingFamilyMutationVariables>;

/**
 * __useLinkExistingFamilyMutation__
 *
 * To run a mutation, you first call `useLinkExistingFamilyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkExistingFamilyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkExistingFamilyMutation, { data, loading, error }] = useLinkExistingFamilyMutation({
 *   variables: {
 *      parentEmail: // value for 'parentEmail'
 *      language: // value for 'language'
 *      primaryTherapistId: // value for 'primaryTherapistId'
 *   },
 * });
 */
export function useLinkExistingFamilyMutation(baseOptions?: Apollo.MutationHookOptions<LinkExistingFamilyMutation, LinkExistingFamilyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkExistingFamilyMutation, LinkExistingFamilyMutationVariables>(LinkExistingFamilyDocument, options);
      }
export type LinkExistingFamilyMutationHookResult = ReturnType<typeof useLinkExistingFamilyMutation>;
export type LinkExistingFamilyMutationResult = Apollo.MutationResult<LinkExistingFamilyMutation>;
export type LinkExistingFamilyMutationOptions = Apollo.BaseMutationOptions<LinkExistingFamilyMutation, LinkExistingFamilyMutationVariables>;
export const SendMessageDocument = gql`
    mutation sendMessage($options: SendMessageOptions!) {
  sendMessage(options: $options)
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const GetConversationsDocument = gql`
    query getConversations($options: ConversationQueryOptions!) {
  conversations(options: $options) {
    id
    read
    users {
      id
      firstName
      lastName
      accountType
      familyId
    }
    messages {
      id
      from {
        id
        firstName
        lastName
      }
      message
      date
      automated
      hasAttachments
    }
    recipientReadAt
    type
    familyId
    archivedAt
    pendingActions {
      id
      reason
    }
    permissions
  }
}
    `;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables> & ({ variables: GetConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
      }
export function useGetConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export function useGetConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsSuspenseQueryHookResult = ReturnType<typeof useGetConversationsSuspenseQuery>;
export type GetConversationsQueryResult = Apollo.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const GetMessageAttachmentsDocument = gql`
    query getMessageAttachments($messageId: Int!, $includeData: Boolean, $asUserId: Int) {
  messageAttachments(
    messageId: $messageId
    includeData: $includeData
    asUserId: $asUserId
  ) {
    name
    mimeType
    base64
  }
}
    `;

/**
 * __useGetMessageAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetMessageAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageAttachmentsQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      includeData: // value for 'includeData'
 *      asUserId: // value for 'asUserId'
 *   },
 * });
 */
export function useGetMessageAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables> & ({ variables: GetMessageAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables>(GetMessageAttachmentsDocument, options);
      }
export function useGetMessageAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables>(GetMessageAttachmentsDocument, options);
        }
export function useGetMessageAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables>(GetMessageAttachmentsDocument, options);
        }
export type GetMessageAttachmentsQueryHookResult = ReturnType<typeof useGetMessageAttachmentsQuery>;
export type GetMessageAttachmentsLazyQueryHookResult = ReturnType<typeof useGetMessageAttachmentsLazyQuery>;
export type GetMessageAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetMessageAttachmentsSuspenseQuery>;
export type GetMessageAttachmentsQueryResult = Apollo.QueryResult<GetMessageAttachmentsQuery, GetMessageAttachmentsQueryVariables>;
export const MarkConversationReadDocument = gql`
    mutation markConversationRead($conversationId: Int!) {
  markConversationRead(conversationId: $conversationId)
}
    `;
export type MarkConversationReadMutationFn = Apollo.MutationFunction<MarkConversationReadMutation, MarkConversationReadMutationVariables>;

/**
 * __useMarkConversationReadMutation__
 *
 * To run a mutation, you first call `useMarkConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationReadMutation, { data, loading, error }] = useMarkConversationReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useMarkConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationReadMutation, MarkConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationReadMutation, MarkConversationReadMutationVariables>(MarkConversationReadDocument, options);
      }
export type MarkConversationReadMutationHookResult = ReturnType<typeof useMarkConversationReadMutation>;
export type MarkConversationReadMutationResult = Apollo.MutationResult<MarkConversationReadMutation>;
export type MarkConversationReadMutationOptions = Apollo.BaseMutationOptions<MarkConversationReadMutation, MarkConversationReadMutationVariables>;
export const GetTherapistChildParentsDocument = gql`
    query getTherapistChildParents {
  therapistChildParents {
    adultId
    childId
  }
}
    `;

/**
 * __useGetTherapistChildParentsQuery__
 *
 * To run a query within a React component, call `useGetTherapistChildParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistChildParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistChildParentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTherapistChildParentsQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>(GetTherapistChildParentsDocument, options);
      }
export function useGetTherapistChildParentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>(GetTherapistChildParentsDocument, options);
        }
export function useGetTherapistChildParentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>(GetTherapistChildParentsDocument, options);
        }
export type GetTherapistChildParentsQueryHookResult = ReturnType<typeof useGetTherapistChildParentsQuery>;
export type GetTherapistChildParentsLazyQueryHookResult = ReturnType<typeof useGetTherapistChildParentsLazyQuery>;
export type GetTherapistChildParentsSuspenseQueryHookResult = ReturnType<typeof useGetTherapistChildParentsSuspenseQuery>;
export type GetTherapistChildParentsQueryResult = Apollo.QueryResult<GetTherapistChildParentsQuery, GetTherapistChildParentsQueryVariables>;
export const GetTherapistCareTeamDocument = gql`
    query getTherapistCareTeam {
  careTeam {
    careCoordinationEnabled
    users {
      id
      firstName
      lastName
      accountType
      email
      ehrUserId
      credentialing
      licensedStates
      profileImageUrl
      createdAt
      lastActiveAt
    }
  }
}
    `;

/**
 * __useGetTherapistCareTeamQuery__
 *
 * To run a query within a React component, call `useGetTherapistCareTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTherapistCareTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTherapistCareTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTherapistCareTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>(GetTherapistCareTeamDocument, options);
      }
export function useGetTherapistCareTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>(GetTherapistCareTeamDocument, options);
        }
export function useGetTherapistCareTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>(GetTherapistCareTeamDocument, options);
        }
export type GetTherapistCareTeamQueryHookResult = ReturnType<typeof useGetTherapistCareTeamQuery>;
export type GetTherapistCareTeamLazyQueryHookResult = ReturnType<typeof useGetTherapistCareTeamLazyQuery>;
export type GetTherapistCareTeamSuspenseQueryHookResult = ReturnType<typeof useGetTherapistCareTeamSuspenseQuery>;
export type GetTherapistCareTeamQueryResult = Apollo.QueryResult<GetTherapistCareTeamQuery, GetTherapistCareTeamQueryVariables>;
export const SendMessageBatchDocument = gql`
    mutation sendMessageBatch($message: String, $options: [ConversationOptions]) {
  sendMessageBatch(message: $message, options: $options)
}
    `;
export type SendMessageBatchMutationFn = Apollo.MutationFunction<SendMessageBatchMutation, SendMessageBatchMutationVariables>;

/**
 * __useSendMessageBatchMutation__
 *
 * To run a mutation, you first call `useSendMessageBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageBatchMutation, { data, loading, error }] = useSendMessageBatchMutation({
 *   variables: {
 *      message: // value for 'message'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSendMessageBatchMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageBatchMutation, SendMessageBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageBatchMutation, SendMessageBatchMutationVariables>(SendMessageBatchDocument, options);
      }
export type SendMessageBatchMutationHookResult = ReturnType<typeof useSendMessageBatchMutation>;
export type SendMessageBatchMutationResult = Apollo.MutationResult<SendMessageBatchMutation>;
export type SendMessageBatchMutationOptions = Apollo.BaseMutationOptions<SendMessageBatchMutation, SendMessageBatchMutationVariables>;
export const GetActivityFeedDocument = gql`
    query getActivityFeed($userIds: [Int]!, $offset: Int, $limit: Int) {
  activityFeed(userIds: $userIds, offset: $offset, limit: $limit) {
    date
    title
    subtitle
    icon
    image
  }
}
    `;

/**
 * __useGetActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityFeedQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<GetActivityFeedQuery, GetActivityFeedQueryVariables> & ({ variables: GetActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityFeedQuery, GetActivityFeedQueryVariables>(GetActivityFeedDocument, options);
      }
export function useGetActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityFeedQuery, GetActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityFeedQuery, GetActivityFeedQueryVariables>(GetActivityFeedDocument, options);
        }
export function useGetActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityFeedQuery, GetActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityFeedQuery, GetActivityFeedQueryVariables>(GetActivityFeedDocument, options);
        }
export type GetActivityFeedQueryHookResult = ReturnType<typeof useGetActivityFeedQuery>;
export type GetActivityFeedLazyQueryHookResult = ReturnType<typeof useGetActivityFeedLazyQuery>;
export type GetActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetActivityFeedSuspenseQuery>;
export type GetActivityFeedQueryResult = Apollo.QueryResult<GetActivityFeedQuery, GetActivityFeedQueryVariables>;
export const CreateConversationDocument = gql`
    mutation createConversation($userIds: [Int]!) {
  createConversation(userIds: $userIds)
}
    `;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const AddConnectionToCareTeamMemberDocument = gql`
    mutation addConnectionToCareTeamMember($connectUserEmail: String!, $connectToCareMemberUserId: Int!) {
  addConnectionToCareTeamMember(
    connectToCareMemberUserId: $connectToCareMemberUserId
    connectUserEmail: $connectUserEmail
    linkUninvitedUser: true
  ) {
    status
    message
  }
}
    `;
export type AddConnectionToCareTeamMemberMutationFn = Apollo.MutationFunction<AddConnectionToCareTeamMemberMutation, AddConnectionToCareTeamMemberMutationVariables>;

/**
 * __useAddConnectionToCareTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddConnectionToCareTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConnectionToCareTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConnectionToCareTeamMemberMutation, { data, loading, error }] = useAddConnectionToCareTeamMemberMutation({
 *   variables: {
 *      connectUserEmail: // value for 'connectUserEmail'
 *      connectToCareMemberUserId: // value for 'connectToCareMemberUserId'
 *   },
 * });
 */
export function useAddConnectionToCareTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddConnectionToCareTeamMemberMutation, AddConnectionToCareTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddConnectionToCareTeamMemberMutation, AddConnectionToCareTeamMemberMutationVariables>(AddConnectionToCareTeamMemberDocument, options);
      }
export type AddConnectionToCareTeamMemberMutationHookResult = ReturnType<typeof useAddConnectionToCareTeamMemberMutation>;
export type AddConnectionToCareTeamMemberMutationResult = Apollo.MutationResult<AddConnectionToCareTeamMemberMutation>;
export type AddConnectionToCareTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddConnectionToCareTeamMemberMutation, AddConnectionToCareTeamMemberMutationVariables>;
export const DeletePendingActionsDocument = gql`
    mutation deletePendingActions($conversationIds: [Int]!) {
  deletePendingActions(conversationIds: $conversationIds)
}
    `;
export type DeletePendingActionsMutationFn = Apollo.MutationFunction<DeletePendingActionsMutation, DeletePendingActionsMutationVariables>;

/**
 * __useDeletePendingActionsMutation__
 *
 * To run a mutation, you first call `useDeletePendingActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePendingActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePendingActionsMutation, { data, loading, error }] = useDeletePendingActionsMutation({
 *   variables: {
 *      conversationIds: // value for 'conversationIds'
 *   },
 * });
 */
export function useDeletePendingActionsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePendingActionsMutation, DeletePendingActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePendingActionsMutation, DeletePendingActionsMutationVariables>(DeletePendingActionsDocument, options);
      }
export type DeletePendingActionsMutationHookResult = ReturnType<typeof useDeletePendingActionsMutation>;
export type DeletePendingActionsMutationResult = Apollo.MutationResult<DeletePendingActionsMutation>;
export type DeletePendingActionsMutationOptions = Apollo.BaseMutationOptions<DeletePendingActionsMutation, DeletePendingActionsMutationVariables>;
export const GetFamiliesDocument = gql`
    query getFamilies($ids: [Int]!) {
  families(ids: $ids) {
    id
    users {
      id
      firstName
      lastName
      accountType
      email
      phoneNumber
      dateOfBirth
      ehrUserId
      groupName
      providerName
    }
  }
}
    `;

/**
 * __useGetFamiliesQuery__
 *
 * To run a query within a React component, call `useGetFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamiliesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetFamiliesQuery(baseOptions: Apollo.QueryHookOptions<GetFamiliesQuery, GetFamiliesQueryVariables> & ({ variables: GetFamiliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFamiliesQuery, GetFamiliesQueryVariables>(GetFamiliesDocument, options);
      }
export function useGetFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFamiliesQuery, GetFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFamiliesQuery, GetFamiliesQueryVariables>(GetFamiliesDocument, options);
        }
export function useGetFamiliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFamiliesQuery, GetFamiliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFamiliesQuery, GetFamiliesQueryVariables>(GetFamiliesDocument, options);
        }
export type GetFamiliesQueryHookResult = ReturnType<typeof useGetFamiliesQuery>;
export type GetFamiliesLazyQueryHookResult = ReturnType<typeof useGetFamiliesLazyQuery>;
export type GetFamiliesSuspenseQueryHookResult = ReturnType<typeof useGetFamiliesSuspenseQuery>;
export type GetFamiliesQueryResult = Apollo.QueryResult<GetFamiliesQuery, GetFamiliesQueryVariables>;
export const LeaveConversationDocument = gql`
    mutation leaveConversation($conversationId: Int) {
  leaveConversation(conversationId: $conversationId)
}
    `;
export type LeaveConversationMutationFn = Apollo.MutationFunction<LeaveConversationMutation, LeaveConversationMutationVariables>;

/**
 * __useLeaveConversationMutation__
 *
 * To run a mutation, you first call `useLeaveConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveConversationMutation, { data, loading, error }] = useLeaveConversationMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useLeaveConversationMutation(baseOptions?: Apollo.MutationHookOptions<LeaveConversationMutation, LeaveConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveConversationMutation, LeaveConversationMutationVariables>(LeaveConversationDocument, options);
      }
export type LeaveConversationMutationHookResult = ReturnType<typeof useLeaveConversationMutation>;
export type LeaveConversationMutationResult = Apollo.MutationResult<LeaveConversationMutation>;
export type LeaveConversationMutationOptions = Apollo.BaseMutationOptions<LeaveConversationMutation, LeaveConversationMutationVariables>;
export const GetUnreadConversationCountDocument = gql`
    query getUnreadConversationCount {
  unreadConversationCount
}
    `;

/**
 * __useGetUnreadConversationCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadConversationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadConversationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadConversationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadConversationCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>(GetUnreadConversationCountDocument, options);
      }
export function useGetUnreadConversationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>(GetUnreadConversationCountDocument, options);
        }
export function useGetUnreadConversationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>(GetUnreadConversationCountDocument, options);
        }
export type GetUnreadConversationCountQueryHookResult = ReturnType<typeof useGetUnreadConversationCountQuery>;
export type GetUnreadConversationCountLazyQueryHookResult = ReturnType<typeof useGetUnreadConversationCountLazyQuery>;
export type GetUnreadConversationCountSuspenseQueryHookResult = ReturnType<typeof useGetUnreadConversationCountSuspenseQuery>;
export type GetUnreadConversationCountQueryResult = Apollo.QueryResult<GetUnreadConversationCountQuery, GetUnreadConversationCountQueryVariables>;
export const GetChildrenByParentEmailDocument = gql`
    query getChildrenByParentEmail($parentEmail: String!) {
  childrenByParentEmail(parentEmail: $parentEmail) {
    id
    firstName
    lastName
    therapists {
      user {
        id
        firstName
        lastName
      }
    }
    parentCoaches {
      user {
        id
        firstName
        lastName
      }
    }
    careCoordinators {
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetChildrenByParentEmailQuery__
 *
 * To run a query within a React component, call `useGetChildrenByParentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenByParentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenByParentEmailQuery({
 *   variables: {
 *      parentEmail: // value for 'parentEmail'
 *   },
 * });
 */
export function useGetChildrenByParentEmailQuery(baseOptions: Apollo.QueryHookOptions<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables> & ({ variables: GetChildrenByParentEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables>(GetChildrenByParentEmailDocument, options);
      }
export function useGetChildrenByParentEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables>(GetChildrenByParentEmailDocument, options);
        }
export function useGetChildrenByParentEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables>(GetChildrenByParentEmailDocument, options);
        }
export type GetChildrenByParentEmailQueryHookResult = ReturnType<typeof useGetChildrenByParentEmailQuery>;
export type GetChildrenByParentEmailLazyQueryHookResult = ReturnType<typeof useGetChildrenByParentEmailLazyQuery>;
export type GetChildrenByParentEmailSuspenseQueryHookResult = ReturnType<typeof useGetChildrenByParentEmailSuspenseQuery>;
export type GetChildrenByParentEmailQueryResult = Apollo.QueryResult<GetChildrenByParentEmailQuery, GetChildrenByParentEmailQueryVariables>;
export const RemoveConnectionToCareTeamMemberDocument = gql`
    mutation removeConnectionToCareTeamMember($disconnectCareMemberUserId: Int, $disconnectAllCareTeamMembers: Boolean, $disconnectUserId: Int!) {
  removeConnectionToCareTeamMember(
    disconnectCareMemberUserId: $disconnectCareMemberUserId
    disconnectAllCareTeamMembers: $disconnectAllCareTeamMembers
    disconnectUserId: $disconnectUserId
  )
}
    `;
export type RemoveConnectionToCareTeamMemberMutationFn = Apollo.MutationFunction<RemoveConnectionToCareTeamMemberMutation, RemoveConnectionToCareTeamMemberMutationVariables>;

/**
 * __useRemoveConnectionToCareTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveConnectionToCareTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConnectionToCareTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConnectionToCareTeamMemberMutation, { data, loading, error }] = useRemoveConnectionToCareTeamMemberMutation({
 *   variables: {
 *      disconnectCareMemberUserId: // value for 'disconnectCareMemberUserId'
 *      disconnectAllCareTeamMembers: // value for 'disconnectAllCareTeamMembers'
 *      disconnectUserId: // value for 'disconnectUserId'
 *   },
 * });
 */
export function useRemoveConnectionToCareTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConnectionToCareTeamMemberMutation, RemoveConnectionToCareTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConnectionToCareTeamMemberMutation, RemoveConnectionToCareTeamMemberMutationVariables>(RemoveConnectionToCareTeamMemberDocument, options);
      }
export type RemoveConnectionToCareTeamMemberMutationHookResult = ReturnType<typeof useRemoveConnectionToCareTeamMemberMutation>;
export type RemoveConnectionToCareTeamMemberMutationResult = Apollo.MutationResult<RemoveConnectionToCareTeamMemberMutation>;
export type RemoveConnectionToCareTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveConnectionToCareTeamMemberMutation, RemoveConnectionToCareTeamMemberMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation deleteMessage($messageId: Int!) {
  deleteMessage(messageId: $messageId)
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const CreateAppointmentDocument = gql`
    mutation createAppointment($appointmentTypeId: String!, $attendeeIds: [Int!]!, $date: String!, $contactMethod: String!) {
  createAppointment(
    appointmentTypeId: $appointmentTypeId
    attendeeIds: $attendeeIds
    date: $date
    contactMethod: $contactMethod
  ) {
    id
    date
    length
    contactMethod
    attendees {
      id
      firstName
      lastName
      familyId
      accountType
    }
    appointmentType {
      id
      name
    }
  }
}
    `;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      attendeeIds: // value for 'attendeeIds'
 *      date: // value for 'date'
 *      contactMethod: // value for 'contactMethod'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const GetAppointmentTypesDocument = gql`
    query getAppointmentTypes {
  appointmentTypes {
    id
    name
    length
    isGroup
    contactMethods
    applicableCareTeamMemberIds
    pricingInfo {
      priceInCents
    }
  }
}
    `;

/**
 * __useGetAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>(GetAppointmentTypesDocument, options);
      }
export function useGetAppointmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>(GetAppointmentTypesDocument, options);
        }
export function useGetAppointmentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>(GetAppointmentTypesDocument, options);
        }
export type GetAppointmentTypesQueryHookResult = ReturnType<typeof useGetAppointmentTypesQuery>;
export type GetAppointmentTypesLazyQueryHookResult = ReturnType<typeof useGetAppointmentTypesLazyQuery>;
export type GetAppointmentTypesSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentTypesSuspenseQuery>;
export type GetAppointmentTypesQueryResult = Apollo.QueryResult<GetAppointmentTypesQuery, GetAppointmentTypesQueryVariables>;
export const GetAvailableDaysDocument = gql`
    query getAvailableDays($dateInMonth: String!, $timeZone: String, $userIds: [Int]!, $appointmentTypeId: String!, $contactMethod: String!, $recurringInterval: RecurringAppointmentInterval, $recurringCount: Int) {
  availableDays(
    dateInMonth: $dateInMonth
    timeZone: $timeZone
    userIds: $userIds
    appointmentTypeId: $appointmentTypeId
    contactMethod: $contactMethod
    recurringInterval: $recurringInterval
    recurringCount: $recurringCount
  ) {
    availableDates
  }
}
    `;

/**
 * __useGetAvailableDaysQuery__
 *
 * To run a query within a React component, call `useGetAvailableDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableDaysQuery({
 *   variables: {
 *      dateInMonth: // value for 'dateInMonth'
 *      timeZone: // value for 'timeZone'
 *      userIds: // value for 'userIds'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      contactMethod: // value for 'contactMethod'
 *      recurringInterval: // value for 'recurringInterval'
 *      recurringCount: // value for 'recurringCount'
 *   },
 * });
 */
export function useGetAvailableDaysQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableDaysQuery, GetAvailableDaysQueryVariables> & ({ variables: GetAvailableDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableDaysQuery, GetAvailableDaysQueryVariables>(GetAvailableDaysDocument, options);
      }
export function useGetAvailableDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableDaysQuery, GetAvailableDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableDaysQuery, GetAvailableDaysQueryVariables>(GetAvailableDaysDocument, options);
        }
export function useGetAvailableDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableDaysQuery, GetAvailableDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableDaysQuery, GetAvailableDaysQueryVariables>(GetAvailableDaysDocument, options);
        }
export type GetAvailableDaysQueryHookResult = ReturnType<typeof useGetAvailableDaysQuery>;
export type GetAvailableDaysLazyQueryHookResult = ReturnType<typeof useGetAvailableDaysLazyQuery>;
export type GetAvailableDaysSuspenseQueryHookResult = ReturnType<typeof useGetAvailableDaysSuspenseQuery>;
export type GetAvailableDaysQueryResult = Apollo.QueryResult<GetAvailableDaysQuery, GetAvailableDaysQueryVariables>;
export const GetAvailableTimeSlotsDocument = gql`
    query getAvailableTimeSlots($startDate: String!, $endDate: String!, $timeZone: String, $userIds: [Int]!, $appointmentTypeId: String!, $contactMethod: String!, $recurringInterval: RecurringAppointmentInterval, $recurringCount: Int) {
  availableTimeSlots(
    startDate: $startDate
    endDate: $endDate
    timeZone: $timeZone
    userIds: $userIds
    appointmentTypeId: $appointmentTypeId
    contactMethod: $contactMethod
    recurringInterval: $recurringInterval
    recurringCount: $recurringCount
  ) {
    userId
    startTime
  }
}
    `;

/**
 * __useGetAvailableTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetAvailableTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTimeSlotsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timeZone: // value for 'timeZone'
 *      userIds: // value for 'userIds'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      contactMethod: // value for 'contactMethod'
 *      recurringInterval: // value for 'recurringInterval'
 *      recurringCount: // value for 'recurringCount'
 *   },
 * });
 */
export function useGetAvailableTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables> & ({ variables: GetAvailableTimeSlotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables>(GetAvailableTimeSlotsDocument, options);
      }
export function useGetAvailableTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables>(GetAvailableTimeSlotsDocument, options);
        }
export function useGetAvailableTimeSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables>(GetAvailableTimeSlotsDocument, options);
        }
export type GetAvailableTimeSlotsQueryHookResult = ReturnType<typeof useGetAvailableTimeSlotsQuery>;
export type GetAvailableTimeSlotsLazyQueryHookResult = ReturnType<typeof useGetAvailableTimeSlotsLazyQuery>;
export type GetAvailableTimeSlotsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableTimeSlotsSuspenseQuery>;
export type GetAvailableTimeSlotsQueryResult = Apollo.QueryResult<GetAvailableTimeSlotsQuery, GetAvailableTimeSlotsQueryVariables>;
export const GetUserDocument = gql`
    query getUser {
  me {
    id
    accountType
    firstName
    lastName
    email
    providerName
    ehrUserId
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetFamilyMembersDocument = gql`
    query getFamilyMembers {
  me {
    id
    accountType
    firstName
    lastName
    email
    dateOfBirth
  }
  familyMembers {
    id
    firstName
    lastName
    accountType
    dateOfBirth
  }
}
    `;

/**
 * __useGetFamilyMembersQuery__
 *
 * To run a query within a React component, call `useGetFamilyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFamilyMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>(GetFamilyMembersDocument, options);
      }
export function useGetFamilyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>(GetFamilyMembersDocument, options);
        }
export function useGetFamilyMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>(GetFamilyMembersDocument, options);
        }
export type GetFamilyMembersQueryHookResult = ReturnType<typeof useGetFamilyMembersQuery>;
export type GetFamilyMembersLazyQueryHookResult = ReturnType<typeof useGetFamilyMembersLazyQuery>;
export type GetFamilyMembersSuspenseQueryHookResult = ReturnType<typeof useGetFamilyMembersSuspenseQuery>;
export type GetFamilyMembersQueryResult = Apollo.QueryResult<GetFamilyMembersQuery, GetFamilyMembersQueryVariables>;
export const GetFormsDocument = gql`
    query getForms($userIds: [Int!], $ids: [String!], $status: FormStatus) {
  forms(userIds: $userIds, ids: $ids, status: $status) {
    id
    user {
      id
      firstName
    }
    formTemplate {
      id
      name
    }
    status
  }
}
    `;

/**
 * __useGetFormsQuery__
 *
 * To run a query within a React component, call `useGetFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
      }
export function useGetFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
        }
export function useGetFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
        }
export type GetFormsQueryHookResult = ReturnType<typeof useGetFormsQuery>;
export type GetFormsLazyQueryHookResult = ReturnType<typeof useGetFormsLazyQuery>;
export type GetFormsSuspenseQueryHookResult = ReturnType<typeof useGetFormsSuspenseQuery>;
export type GetFormsQueryResult = Apollo.QueryResult<GetFormsQuery, GetFormsQueryVariables>;
export const CreateEhrApiKeysDocument = gql`
    mutation createEhrApiKeys($userIds: [Int!]) {
  createEhrApiKeys(userIds: $userIds) {
    apiKey
    userId
    ehrUserId
  }
}
    `;
export type CreateEhrApiKeysMutationFn = Apollo.MutationFunction<CreateEhrApiKeysMutation, CreateEhrApiKeysMutationVariables>;

/**
 * __useCreateEhrApiKeysMutation__
 *
 * To run a mutation, you first call `useCreateEhrApiKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEhrApiKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEhrApiKeysMutation, { data, loading, error }] = useCreateEhrApiKeysMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useCreateEhrApiKeysMutation(baseOptions?: Apollo.MutationHookOptions<CreateEhrApiKeysMutation, CreateEhrApiKeysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEhrApiKeysMutation, CreateEhrApiKeysMutationVariables>(CreateEhrApiKeysDocument, options);
      }
export type CreateEhrApiKeysMutationHookResult = ReturnType<typeof useCreateEhrApiKeysMutation>;
export type CreateEhrApiKeysMutationResult = Apollo.MutationResult<CreateEhrApiKeysMutation>;
export type CreateEhrApiKeysMutationOptions = Apollo.BaseMutationOptions<CreateEhrApiKeysMutation, CreateEhrApiKeysMutationVariables>;
export const GetGuidingStarsDocument = gql`
    query getGuidingStars($userIds: [Int!]!) {
  guidingStars(userIds: $userIds) {
    id
    userId
    description
  }
}
    `;

/**
 * __useGetGuidingStarsQuery__
 *
 * To run a query within a React component, call `useGetGuidingStarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuidingStarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuidingStarsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetGuidingStarsQuery(baseOptions: Apollo.QueryHookOptions<GetGuidingStarsQuery, GetGuidingStarsQueryVariables> & ({ variables: GetGuidingStarsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuidingStarsQuery, GetGuidingStarsQueryVariables>(GetGuidingStarsDocument, options);
      }
export function useGetGuidingStarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuidingStarsQuery, GetGuidingStarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuidingStarsQuery, GetGuidingStarsQueryVariables>(GetGuidingStarsDocument, options);
        }
export function useGetGuidingStarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuidingStarsQuery, GetGuidingStarsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuidingStarsQuery, GetGuidingStarsQueryVariables>(GetGuidingStarsDocument, options);
        }
export type GetGuidingStarsQueryHookResult = ReturnType<typeof useGetGuidingStarsQuery>;
export type GetGuidingStarsLazyQueryHookResult = ReturnType<typeof useGetGuidingStarsLazyQuery>;
export type GetGuidingStarsSuspenseQueryHookResult = ReturnType<typeof useGetGuidingStarsSuspenseQuery>;
export type GetGuidingStarsQueryResult = Apollo.QueryResult<GetGuidingStarsQuery, GetGuidingStarsQueryVariables>;
export const GetCareTeamMemberMatchesDocument = gql`
    query getCareTeamMemberMatches($userIds: [Int!]!) {
  careTeamMemberMatches(userIds: $userIds) {
    user {
      id
      firstName
      lastName
      accountType
      familyId
    }
    careTeamMember {
      id
      firstName
      lastName
      accountType
      credentialing
      profileImageUrl
    }
  }
}
    `;

/**
 * __useGetCareTeamMemberMatchesQuery__
 *
 * To run a query within a React component, call `useGetCareTeamMemberMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareTeamMemberMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareTeamMemberMatchesQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetCareTeamMemberMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables> & ({ variables: GetCareTeamMemberMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables>(GetCareTeamMemberMatchesDocument, options);
      }
export function useGetCareTeamMemberMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables>(GetCareTeamMemberMatchesDocument, options);
        }
export function useGetCareTeamMemberMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables>(GetCareTeamMemberMatchesDocument, options);
        }
export type GetCareTeamMemberMatchesQueryHookResult = ReturnType<typeof useGetCareTeamMemberMatchesQuery>;
export type GetCareTeamMemberMatchesLazyQueryHookResult = ReturnType<typeof useGetCareTeamMemberMatchesLazyQuery>;
export type GetCareTeamMemberMatchesSuspenseQueryHookResult = ReturnType<typeof useGetCareTeamMemberMatchesSuspenseQuery>;
export type GetCareTeamMemberMatchesQueryResult = Apollo.QueryResult<GetCareTeamMemberMatchesQuery, GetCareTeamMemberMatchesQueryVariables>;
export const GetFamilyMemberCareTeamMatchesDocument = gql`
    query getFamilyMemberCareTeamMatches($userIds: [Int!]!) {
  familyMembers {
    id
    firstName
    lastName
    accountType
  }
  careTeamMemberMatches(userIds: $userIds) {
    user {
      id
      firstName
      lastName
      accountType
      familyId
    }
    careTeamMember {
      id
      firstName
      lastName
      accountType
      credentialing
      profileImageUrl
    }
  }
}
    `;

/**
 * __useGetFamilyMemberCareTeamMatchesQuery__
 *
 * To run a query within a React component, call `useGetFamilyMemberCareTeamMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyMemberCareTeamMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyMemberCareTeamMatchesQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetFamilyMemberCareTeamMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables> & ({ variables: GetFamilyMemberCareTeamMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables>(GetFamilyMemberCareTeamMatchesDocument, options);
      }
export function useGetFamilyMemberCareTeamMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables>(GetFamilyMemberCareTeamMatchesDocument, options);
        }
export function useGetFamilyMemberCareTeamMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables>(GetFamilyMemberCareTeamMatchesDocument, options);
        }
export type GetFamilyMemberCareTeamMatchesQueryHookResult = ReturnType<typeof useGetFamilyMemberCareTeamMatchesQuery>;
export type GetFamilyMemberCareTeamMatchesLazyQueryHookResult = ReturnType<typeof useGetFamilyMemberCareTeamMatchesLazyQuery>;
export type GetFamilyMemberCareTeamMatchesSuspenseQueryHookResult = ReturnType<typeof useGetFamilyMemberCareTeamMatchesSuspenseQuery>;
export type GetFamilyMemberCareTeamMatchesQueryResult = Apollo.QueryResult<GetFamilyMemberCareTeamMatchesQuery, GetFamilyMemberCareTeamMatchesQueryVariables>;
export const GetCareScreenersDocument = gql`
    query getCareScreeners($userId: Int!, $filterByLatest: Boolean) {
  careScreeners(userId: $userId, filterByLatest: $filterByLatest) {
    id
    typeformId
    typeformResponseId
    path
    email
    phoneNumber
    schedulingQueryStartDate
    createdAt
  }
}
    `;

/**
 * __useGetCareScreenersQuery__
 *
 * To run a query within a React component, call `useGetCareScreenersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareScreenersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareScreenersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      filterByLatest: // value for 'filterByLatest'
 *   },
 * });
 */
export function useGetCareScreenersQuery(baseOptions: Apollo.QueryHookOptions<GetCareScreenersQuery, GetCareScreenersQueryVariables> & ({ variables: GetCareScreenersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareScreenersQuery, GetCareScreenersQueryVariables>(GetCareScreenersDocument, options);
      }
export function useGetCareScreenersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareScreenersQuery, GetCareScreenersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareScreenersQuery, GetCareScreenersQueryVariables>(GetCareScreenersDocument, options);
        }
export function useGetCareScreenersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareScreenersQuery, GetCareScreenersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCareScreenersQuery, GetCareScreenersQueryVariables>(GetCareScreenersDocument, options);
        }
export type GetCareScreenersQueryHookResult = ReturnType<typeof useGetCareScreenersQuery>;
export type GetCareScreenersLazyQueryHookResult = ReturnType<typeof useGetCareScreenersLazyQuery>;
export type GetCareScreenersSuspenseQueryHookResult = ReturnType<typeof useGetCareScreenersSuspenseQuery>;
export type GetCareScreenersQueryResult = Apollo.QueryResult<GetCareScreenersQuery, GetCareScreenersQueryVariables>;
export const SendCareTeamMemberMatchesEmailDocument = gql`
    mutation sendCareTeamMemberMatchesEmail($contextUserId: Int!, $emailRecipientUserIds: [Int!]!) {
  sendCareTeamMemberMatchesEmail(
    contextUserId: $contextUserId
    emailRecipientUserIds: $emailRecipientUserIds
  ) {
    operationName
    mutatedObjects {
      id
      data
    }
    errors
  }
}
    `;
export type SendCareTeamMemberMatchesEmailMutationFn = Apollo.MutationFunction<SendCareTeamMemberMatchesEmailMutation, SendCareTeamMemberMatchesEmailMutationVariables>;

/**
 * __useSendCareTeamMemberMatchesEmailMutation__
 *
 * To run a mutation, you first call `useSendCareTeamMemberMatchesEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCareTeamMemberMatchesEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCareTeamMemberMatchesEmailMutation, { data, loading, error }] = useSendCareTeamMemberMatchesEmailMutation({
 *   variables: {
 *      contextUserId: // value for 'contextUserId'
 *      emailRecipientUserIds: // value for 'emailRecipientUserIds'
 *   },
 * });
 */
export function useSendCareTeamMemberMatchesEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCareTeamMemberMatchesEmailMutation, SendCareTeamMemberMatchesEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCareTeamMemberMatchesEmailMutation, SendCareTeamMemberMatchesEmailMutationVariables>(SendCareTeamMemberMatchesEmailDocument, options);
      }
export type SendCareTeamMemberMatchesEmailMutationHookResult = ReturnType<typeof useSendCareTeamMemberMatchesEmailMutation>;
export type SendCareTeamMemberMatchesEmailMutationResult = Apollo.MutationResult<SendCareTeamMemberMatchesEmailMutation>;
export type SendCareTeamMemberMatchesEmailMutationOptions = Apollo.BaseMutationOptions<SendCareTeamMemberMatchesEmailMutation, SendCareTeamMemberMatchesEmailMutationVariables>;
export const SetCareTeamMemberMatchesDocument = gql`
    mutation setCareTeamMemberMatches($userId: Int!, $careTeamMemberIds: [Int!]!, $retainCareCoordinatorMatches: Boolean) {
  setCareTeamMemberMatches(
    userId: $userId
    careTeamMemberIds: $careTeamMemberIds
    retainCareCoordinatorMatches: $retainCareCoordinatorMatches
  ) {
    user {
      id
      firstName
      lastName
      accountType
      familyId
    }
    careTeamMember {
      id
      firstName
      lastName
      accountType
    }
  }
}
    `;
export type SetCareTeamMemberMatchesMutationFn = Apollo.MutationFunction<SetCareTeamMemberMatchesMutation, SetCareTeamMemberMatchesMutationVariables>;

/**
 * __useSetCareTeamMemberMatchesMutation__
 *
 * To run a mutation, you first call `useSetCareTeamMemberMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCareTeamMemberMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCareTeamMemberMatchesMutation, { data, loading, error }] = useSetCareTeamMemberMatchesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      careTeamMemberIds: // value for 'careTeamMemberIds'
 *      retainCareCoordinatorMatches: // value for 'retainCareCoordinatorMatches'
 *   },
 * });
 */
export function useSetCareTeamMemberMatchesMutation(baseOptions?: Apollo.MutationHookOptions<SetCareTeamMemberMatchesMutation, SetCareTeamMemberMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCareTeamMemberMatchesMutation, SetCareTeamMemberMatchesMutationVariables>(SetCareTeamMemberMatchesDocument, options);
      }
export type SetCareTeamMemberMatchesMutationHookResult = ReturnType<typeof useSetCareTeamMemberMatchesMutation>;
export type SetCareTeamMemberMatchesMutationResult = Apollo.MutationResult<SetCareTeamMemberMatchesMutation>;
export type SetCareTeamMemberMatchesMutationOptions = Apollo.BaseMutationOptions<SetCareTeamMemberMatchesMutation, SetCareTeamMemberMatchesMutationVariables>;
export const CreateInsuranceCardDocument = gql`
    mutation createInsuranceCard($userIds: [Int!]!, $frontImage: FileInput!, $backImage: FileInput!) {
  createInsuranceCard(
    userIds: $userIds
    frontImage: $frontImage
    backImage: $backImage
  ) {
    id
    userIds
    createdByUserId
    createdAt
    frontImage {
      name
      mimeType
      path
    }
    backImage {
      name
      mimeType
      path
    }
  }
}
    `;
export type CreateInsuranceCardMutationFn = Apollo.MutationFunction<CreateInsuranceCardMutation, CreateInsuranceCardMutationVariables>;

/**
 * __useCreateInsuranceCardMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceCardMutation, { data, loading, error }] = useCreateInsuranceCardMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      frontImage: // value for 'frontImage'
 *      backImage: // value for 'backImage'
 *   },
 * });
 */
export function useCreateInsuranceCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceCardMutation, CreateInsuranceCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceCardMutation, CreateInsuranceCardMutationVariables>(CreateInsuranceCardDocument, options);
      }
export type CreateInsuranceCardMutationHookResult = ReturnType<typeof useCreateInsuranceCardMutation>;
export type CreateInsuranceCardMutationResult = Apollo.MutationResult<CreateInsuranceCardMutation>;
export type CreateInsuranceCardMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceCardMutation, CreateInsuranceCardMutationVariables>;
export const SearchExternalOrganizationsDocument = gql`
    query searchExternalOrganizations($searchText: String!) {
  searchExternalOrganizations(searchText: $searchText) {
    id
    name
  }
}
    `;

/**
 * __useSearchExternalOrganizationsQuery__
 *
 * To run a query within a React component, call `useSearchExternalOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExternalOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExternalOrganizationsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchExternalOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables> & ({ variables: SearchExternalOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables>(SearchExternalOrganizationsDocument, options);
      }
export function useSearchExternalOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables>(SearchExternalOrganizationsDocument, options);
        }
export function useSearchExternalOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables>(SearchExternalOrganizationsDocument, options);
        }
export type SearchExternalOrganizationsQueryHookResult = ReturnType<typeof useSearchExternalOrganizationsQuery>;
export type SearchExternalOrganizationsLazyQueryHookResult = ReturnType<typeof useSearchExternalOrganizationsLazyQuery>;
export type SearchExternalOrganizationsSuspenseQueryHookResult = ReturnType<typeof useSearchExternalOrganizationsSuspenseQuery>;
export type SearchExternalOrganizationsQueryResult = Apollo.QueryResult<SearchExternalOrganizationsQuery, SearchExternalOrganizationsQueryVariables>;
export const GetExternalOrganizationsDocument = gql`
    query getExternalOrganizations($ids: [Int!]!) {
  externalOrganizations(ids: $ids, limit: 10, offset: 0) {
    id
    name
  }
}
    `;

/**
 * __useGetExternalOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetExternalOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalOrganizationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetExternalOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables> & ({ variables: GetExternalOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>(GetExternalOrganizationsDocument, options);
      }
export function useGetExternalOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>(GetExternalOrganizationsDocument, options);
        }
export function useGetExternalOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>(GetExternalOrganizationsDocument, options);
        }
export type GetExternalOrganizationsQueryHookResult = ReturnType<typeof useGetExternalOrganizationsQuery>;
export type GetExternalOrganizationsLazyQueryHookResult = ReturnType<typeof useGetExternalOrganizationsLazyQuery>;
export type GetExternalOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetExternalOrganizationsSuspenseQuery>;
export type GetExternalOrganizationsQueryResult = Apollo.QueryResult<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>;
export const SearchExternalProvidersDocument = gql`
    query searchExternalProviders($searchText: String!, $externalOrganizationId: Int!) {
  searchExternalProviders(
    searchText: $searchText
    externalOrganizationId: $externalOrganizationId
  ) {
    id
    contact {
      firstName
      lastName
      fullName
    }
  }
}
    `;

/**
 * __useSearchExternalProvidersQuery__
 *
 * To run a query within a React component, call `useSearchExternalProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExternalProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExternalProvidersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      externalOrganizationId: // value for 'externalOrganizationId'
 *   },
 * });
 */
export function useSearchExternalProvidersQuery(baseOptions: Apollo.QueryHookOptions<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables> & ({ variables: SearchExternalProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables>(SearchExternalProvidersDocument, options);
      }
export function useSearchExternalProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables>(SearchExternalProvidersDocument, options);
        }
export function useSearchExternalProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables>(SearchExternalProvidersDocument, options);
        }
export type SearchExternalProvidersQueryHookResult = ReturnType<typeof useSearchExternalProvidersQuery>;
export type SearchExternalProvidersLazyQueryHookResult = ReturnType<typeof useSearchExternalProvidersLazyQuery>;
export type SearchExternalProvidersSuspenseQueryHookResult = ReturnType<typeof useSearchExternalProvidersSuspenseQuery>;
export type SearchExternalProvidersQueryResult = Apollo.QueryResult<SearchExternalProvidersQuery, SearchExternalProvidersQueryVariables>;
export const CreateExternalOrganizationDocument = gql`
    mutation createExternalOrganization($input: CreateExternalOrganizationInput!) {
  createExternalOrganization(input: $input) {
    id
    name
  }
}
    `;
export type CreateExternalOrganizationMutationFn = Apollo.MutationFunction<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>;

/**
 * __useCreateExternalOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateExternalOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalOrganizationMutation, { data, loading, error }] = useCreateExternalOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>(CreateExternalOrganizationDocument, options);
      }
export type CreateExternalOrganizationMutationHookResult = ReturnType<typeof useCreateExternalOrganizationMutation>;
export type CreateExternalOrganizationMutationResult = Apollo.MutationResult<CreateExternalOrganizationMutation>;
export type CreateExternalOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>;
export const CreateExternalProviderDocument = gql`
    mutation createExternalProvider($input: CreateExternalProviderInput!) {
  createExternalProvider(input: $input) {
    id
    contact {
      firstName
      lastName
      fullName
    }
  }
}
    `;
export type CreateExternalProviderMutationFn = Apollo.MutationFunction<CreateExternalProviderMutation, CreateExternalProviderMutationVariables>;

/**
 * __useCreateExternalProviderMutation__
 *
 * To run a mutation, you first call `useCreateExternalProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalProviderMutation, { data, loading, error }] = useCreateExternalProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalProviderMutation, CreateExternalProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalProviderMutation, CreateExternalProviderMutationVariables>(CreateExternalProviderDocument, options);
      }
export type CreateExternalProviderMutationHookResult = ReturnType<typeof useCreateExternalProviderMutation>;
export type CreateExternalProviderMutationResult = Apollo.MutationResult<CreateExternalProviderMutation>;
export type CreateExternalProviderMutationOptions = Apollo.BaseMutationOptions<CreateExternalProviderMutation, CreateExternalProviderMutationVariables>;
export const UpdateExternalProviderDocument = gql`
    mutation updateExternalProvider($id: Int!, $input: UpdateExternalProviderInput!) {
  updateExternalProvider(id: $id, input: $input) {
    id
    receiveUpdates
  }
}
    `;
export type UpdateExternalProviderMutationFn = Apollo.MutationFunction<UpdateExternalProviderMutation, UpdateExternalProviderMutationVariables>;

/**
 * __useUpdateExternalProviderMutation__
 *
 * To run a mutation, you first call `useUpdateExternalProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalProviderMutation, { data, loading, error }] = useUpdateExternalProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalProviderMutation, UpdateExternalProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalProviderMutation, UpdateExternalProviderMutationVariables>(UpdateExternalProviderDocument, options);
      }
export type UpdateExternalProviderMutationHookResult = ReturnType<typeof useUpdateExternalProviderMutation>;
export type UpdateExternalProviderMutationResult = Apollo.MutationResult<UpdateExternalProviderMutation>;
export type UpdateExternalProviderMutationOptions = Apollo.BaseMutationOptions<UpdateExternalProviderMutation, UpdateExternalProviderMutationVariables>;
export const GetReferralsDocument = gql`
    query getReferrals($limit: Int, $offset: Int, $externalProviderIds: [Int!]) {
  referrals(
    limit: $limit
    offset: $offset
    externalProviderIds: $externalProviderIds
  ) {
    id
    createdAt
    note
    status
    externalProvider {
      id
      contact {
        firstName
        lastName
        fullName
        email
        phoneNumber
        faxNumber
        businessName
      }
    }
    externalOrganizationId
    externalOrganization {
      id
      name
      stateCode
      partnerType
      utmSource
      utmMedium
      utmCampaign
    }
    referredClients {
      id
      type
      contact {
        firstName
        lastName
        fullName
        email
        phoneNumber
        dob
      }
      isCareRecipient
      serviceLine
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetReferralsQuery__
 *
 * To run a query within a React component, call `useGetReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      externalProviderIds: // value for 'externalProviderIds'
 *   },
 * });
 */
export function useGetReferralsQuery(baseOptions?: Apollo.QueryHookOptions<GetReferralsQuery, GetReferralsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralsQuery, GetReferralsQueryVariables>(GetReferralsDocument, options);
      }
export function useGetReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralsQuery, GetReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralsQuery, GetReferralsQueryVariables>(GetReferralsDocument, options);
        }
export function useGetReferralsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferralsQuery, GetReferralsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferralsQuery, GetReferralsQueryVariables>(GetReferralsDocument, options);
        }
export type GetReferralsQueryHookResult = ReturnType<typeof useGetReferralsQuery>;
export type GetReferralsLazyQueryHookResult = ReturnType<typeof useGetReferralsLazyQuery>;
export type GetReferralsSuspenseQueryHookResult = ReturnType<typeof useGetReferralsSuspenseQuery>;
export type GetReferralsQueryResult = Apollo.QueryResult<GetReferralsQuery, GetReferralsQueryVariables>;
export const GetClientExternalPreviewsDocument = gql`
    query getClientExternalPreviews($externalProviderIds: [Int!]) {
  clientExternalPreviews(externalProviderIds: $externalProviderIds) {
    firstName
    lastName
    dateAdded
    status
    details
    hasProgressSummary
    progressSummaryUserId
  }
}
    `;

/**
 * __useGetClientExternalPreviewsQuery__
 *
 * To run a query within a React component, call `useGetClientExternalPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientExternalPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientExternalPreviewsQuery({
 *   variables: {
 *      externalProviderIds: // value for 'externalProviderIds'
 *   },
 * });
 */
export function useGetClientExternalPreviewsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>(GetClientExternalPreviewsDocument, options);
      }
export function useGetClientExternalPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>(GetClientExternalPreviewsDocument, options);
        }
export function useGetClientExternalPreviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>(GetClientExternalPreviewsDocument, options);
        }
export type GetClientExternalPreviewsQueryHookResult = ReturnType<typeof useGetClientExternalPreviewsQuery>;
export type GetClientExternalPreviewsLazyQueryHookResult = ReturnType<typeof useGetClientExternalPreviewsLazyQuery>;
export type GetClientExternalPreviewsSuspenseQueryHookResult = ReturnType<typeof useGetClientExternalPreviewsSuspenseQuery>;
export type GetClientExternalPreviewsQueryResult = Apollo.QueryResult<GetClientExternalPreviewsQuery, GetClientExternalPreviewsQueryVariables>;
export const GetReferringProviderStatsDocument = gql`
    query getReferringProviderStats($externalProviderId: Int!) {
  referringProviderStats(externalProviderId: $externalProviderId) {
    referralsMade
    therapySessionsCompleted
  }
}
    `;

/**
 * __useGetReferringProviderStatsQuery__
 *
 * To run a query within a React component, call `useGetReferringProviderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferringProviderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @example
 * const { data, loading, error } = useGetReferringProviderStatsQuery({
 *   variables: {
 *      externalProviderId: // value for 'externalProviderId'
 *   },
 * });
 */
export function useGetReferringProviderStatsQuery(baseOptions: Apollo.QueryHookOptions<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>(GetReferringProviderStatsDocument, options);
      }
export function useGetReferringProviderStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>(GetReferringProviderStatsDocument, options);
        }
export function useGetReferringProviderStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>(GetReferringProviderStatsDocument, options);
        }
export type GetReferringProviderStatsQueryHookResult = ReturnType<typeof useGetReferringProviderStatsQuery>;
export type GetReferringProviderStatsLazyQueryHookResult = ReturnType<typeof useGetReferringProviderStatsLazyQuery>;
export type GetReferringProviderStatsSuspenseQueryHookResult = ReturnType<typeof useGetReferringProviderStatsSuspenseQuery>;
export type GetReferringProviderStatsQueryResult = Apollo.QueryResult<GetReferringProviderStatsQuery, GetReferringProviderStatsQueryVariables>;
export const GetClientProgressSummaryDocument = gql`
    query getClientProgressSummary($userId: Int!) {
  clientProgressSummary(userId: $userId) {
    summaryDate
    intakeDate
    intakeConcerns
    clientDob
    referringProvider
    diagnosis
    childGoals
    familyGoals
    sessionsCompleted
    sessionsShowRate
  }
}
    `;

/**
 * __useGetClientProgressSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientProgressSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientProgressSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientProgressSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClientProgressSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables> & ({ variables: GetClientProgressSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables>(GetClientProgressSummaryDocument, options);
      }
export function useGetClientProgressSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables>(GetClientProgressSummaryDocument, options);
        }
export function useGetClientProgressSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables>(GetClientProgressSummaryDocument, options);
        }
export type GetClientProgressSummaryQueryHookResult = ReturnType<typeof useGetClientProgressSummaryQuery>;
export type GetClientProgressSummaryLazyQueryHookResult = ReturnType<typeof useGetClientProgressSummaryLazyQuery>;
export type GetClientProgressSummarySuspenseQueryHookResult = ReturnType<typeof useGetClientProgressSummarySuspenseQuery>;
export type GetClientProgressSummaryQueryResult = Apollo.QueryResult<GetClientProgressSummaryQuery, GetClientProgressSummaryQueryVariables>;
export const CreateReferralDocument = gql`
    mutation createReferral($input: CreateReferralInput!) {
  createReferral(input: $input) {
    id
  }
}
    `;
export type CreateReferralMutationFn = Apollo.MutationFunction<CreateReferralMutation, CreateReferralMutationVariables>;

/**
 * __useCreateReferralMutation__
 *
 * To run a mutation, you first call `useCreateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferralMutation, { data, loading, error }] = useCreateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferralMutation, CreateReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferralMutation, CreateReferralMutationVariables>(CreateReferralDocument, options);
      }
export type CreateReferralMutationHookResult = ReturnType<typeof useCreateReferralMutation>;
export type CreateReferralMutationResult = Apollo.MutationResult<CreateReferralMutation>;
export type CreateReferralMutationOptions = Apollo.BaseMutationOptions<CreateReferralMutation, CreateReferralMutationVariables>;
export const GetExternalProvidersDocument = gql`
    query getExternalProviders($ids: [Int!], $limit: Int, $offset: Int, $searchText: String) {
  getExternalProviders(
    ids: $ids
    limit: $limit
    offset: $offset
    searchText: $searchText
  ) {
    id
    contact {
      firstName
      lastName
      fullName
      email
      phoneNumber
      businessName
    }
    externalOrganizationId
    externalOrganization {
      id
      name
      stateCode
      partnerType
      canReceiveUpdates
    }
    receiveUpdates
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetExternalProvidersQuery__
 *
 * To run a query within a React component, call `useGetExternalProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalProvidersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetExternalProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>(GetExternalProvidersDocument, options);
      }
export function useGetExternalProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>(GetExternalProvidersDocument, options);
        }
export function useGetExternalProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>(GetExternalProvidersDocument, options);
        }
export type GetExternalProvidersQueryHookResult = ReturnType<typeof useGetExternalProvidersQuery>;
export type GetExternalProvidersLazyQueryHookResult = ReturnType<typeof useGetExternalProvidersLazyQuery>;
export type GetExternalProvidersSuspenseQueryHookResult = ReturnType<typeof useGetExternalProvidersSuspenseQuery>;
export type GetExternalProvidersQueryResult = Apollo.QueryResult<GetExternalProvidersQuery, GetExternalProvidersQueryVariables>;
export const GetExternalOrganizationsListDocument = gql`
    query getExternalOrganizationsList($limit: Int!, $offset: Int!, $searchText: String) {
  externalOrganizations(limit: $limit, offset: $offset, searchText: $searchText) {
    id
    name
    stateCode
    partnerType
    canReceiveUpdates
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetExternalOrganizationsListQuery__
 *
 * To run a query within a React component, call `useGetExternalOrganizationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalOrganizationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalOrganizationsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetExternalOrganizationsListQuery(baseOptions: Apollo.QueryHookOptions<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables> & ({ variables: GetExternalOrganizationsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables>(GetExternalOrganizationsListDocument, options);
      }
export function useGetExternalOrganizationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables>(GetExternalOrganizationsListDocument, options);
        }
export function useGetExternalOrganizationsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables>(GetExternalOrganizationsListDocument, options);
        }
export type GetExternalOrganizationsListQueryHookResult = ReturnType<typeof useGetExternalOrganizationsListQuery>;
export type GetExternalOrganizationsListLazyQueryHookResult = ReturnType<typeof useGetExternalOrganizationsListLazyQuery>;
export type GetExternalOrganizationsListSuspenseQueryHookResult = ReturnType<typeof useGetExternalOrganizationsListSuspenseQuery>;
export type GetExternalOrganizationsListQueryResult = Apollo.QueryResult<GetExternalOrganizationsListQuery, GetExternalOrganizationsListQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($searchText: String!) {
  users(searchText: $searchText) {
    id
    firstName
    lastName
    accountType
    email
    phoneNumber
    dateOfBirth
    ehrUserId
    groupName
    familyId
    providerName
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables> & ({ variables: SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const SearchCareScreenersDocument = gql`
    query searchCareScreeners($searchText: String!) {
  careScreeners(searchText: $searchText) {
    id
    email
    phoneNumber
    path
    consultStatus
    directIntakeStatus
    createdAt
    userId
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useSearchCareScreenersQuery__
 *
 * To run a query within a React component, call `useSearchCareScreenersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCareScreenersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCareScreenersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchCareScreenersQuery(baseOptions: Apollo.QueryHookOptions<SearchCareScreenersQuery, SearchCareScreenersQueryVariables> & ({ variables: SearchCareScreenersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCareScreenersQuery, SearchCareScreenersQueryVariables>(SearchCareScreenersDocument, options);
      }
export function useSearchCareScreenersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCareScreenersQuery, SearchCareScreenersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCareScreenersQuery, SearchCareScreenersQueryVariables>(SearchCareScreenersDocument, options);
        }
export function useSearchCareScreenersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCareScreenersQuery, SearchCareScreenersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCareScreenersQuery, SearchCareScreenersQueryVariables>(SearchCareScreenersDocument, options);
        }
export type SearchCareScreenersQueryHookResult = ReturnType<typeof useSearchCareScreenersQuery>;
export type SearchCareScreenersLazyQueryHookResult = ReturnType<typeof useSearchCareScreenersLazyQuery>;
export type SearchCareScreenersSuspenseQueryHookResult = ReturnType<typeof useSearchCareScreenersSuspenseQuery>;
export type SearchCareScreenersQueryResult = Apollo.QueryResult<SearchCareScreenersQuery, SearchCareScreenersQueryVariables>;
export const SearchEhrUsersDocument = gql`
    query searchEhrUsers($searchText: String!) {
  ehrUsers(searchText: $searchText) {
    id
    manateeUserId
    active
    firstName
    lastName
    email
    phoneNumber
    groupName
  }
}
    `;

/**
 * __useSearchEhrUsersQuery__
 *
 * To run a query within a React component, call `useSearchEhrUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEhrUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEhrUsersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchEhrUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchEhrUsersQuery, SearchEhrUsersQueryVariables> & ({ variables: SearchEhrUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEhrUsersQuery, SearchEhrUsersQueryVariables>(SearchEhrUsersDocument, options);
      }
export function useSearchEhrUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEhrUsersQuery, SearchEhrUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEhrUsersQuery, SearchEhrUsersQueryVariables>(SearchEhrUsersDocument, options);
        }
export function useSearchEhrUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEhrUsersQuery, SearchEhrUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEhrUsersQuery, SearchEhrUsersQueryVariables>(SearchEhrUsersDocument, options);
        }
export type SearchEhrUsersQueryHookResult = ReturnType<typeof useSearchEhrUsersQuery>;
export type SearchEhrUsersLazyQueryHookResult = ReturnType<typeof useSearchEhrUsersLazyQuery>;
export type SearchEhrUsersSuspenseQueryHookResult = ReturnType<typeof useSearchEhrUsersSuspenseQuery>;
export type SearchEhrUsersQueryResult = Apollo.QueryResult<SearchEhrUsersQuery, SearchEhrUsersQueryVariables>;
export const SearchReferralsDocument = gql`
    query searchReferrals($searchText: String!) {
  referrals(searchText: $searchText) {
    id
    status
    createdAt
    externalProvider {
      id
      contact {
        firstName
        lastName
        fullName
        email
        phoneNumber
        businessName
      }
    }
    referredClients {
      id
      type
      userId
      contact {
        firstName
        lastName
        fullName
        email
        phoneNumber
      }
      isCareRecipient
    }
  }
}
    `;

/**
 * __useSearchReferralsQuery__
 *
 * To run a query within a React component, call `useSearchReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchReferralsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchReferralsQuery(baseOptions: Apollo.QueryHookOptions<SearchReferralsQuery, SearchReferralsQueryVariables> & ({ variables: SearchReferralsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchReferralsQuery, SearchReferralsQueryVariables>(SearchReferralsDocument, options);
      }
export function useSearchReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchReferralsQuery, SearchReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchReferralsQuery, SearchReferralsQueryVariables>(SearchReferralsDocument, options);
        }
export function useSearchReferralsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchReferralsQuery, SearchReferralsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchReferralsQuery, SearchReferralsQueryVariables>(SearchReferralsDocument, options);
        }
export type SearchReferralsQueryHookResult = ReturnType<typeof useSearchReferralsQuery>;
export type SearchReferralsLazyQueryHookResult = ReturnType<typeof useSearchReferralsLazyQuery>;
export type SearchReferralsSuspenseQueryHookResult = ReturnType<typeof useSearchReferralsSuspenseQuery>;
export type SearchReferralsQueryResult = Apollo.QueryResult<SearchReferralsQuery, SearchReferralsQueryVariables>;
export const CreateOneTimeAuthLinkDocument = gql`
    mutation createOneTimeAuthLink($externalProviderId: Int!, $sendEmail: Boolean) {
  createOneTimeAuthLink(
    externalProviderId: $externalProviderId
    sendEmail: $sendEmail
  ) {
    link
    message
    success
  }
}
    `;
export type CreateOneTimeAuthLinkMutationFn = Apollo.MutationFunction<CreateOneTimeAuthLinkMutation, CreateOneTimeAuthLinkMutationVariables>;

/**
 * __useCreateOneTimeAuthLinkMutation__
 *
 * To run a mutation, you first call `useCreateOneTimeAuthLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneTimeAuthLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneTimeAuthLinkMutation, { data, loading, error }] = useCreateOneTimeAuthLinkMutation({
 *   variables: {
 *      externalProviderId: // value for 'externalProviderId'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useCreateOneTimeAuthLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneTimeAuthLinkMutation, CreateOneTimeAuthLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneTimeAuthLinkMutation, CreateOneTimeAuthLinkMutationVariables>(CreateOneTimeAuthLinkDocument, options);
      }
export type CreateOneTimeAuthLinkMutationHookResult = ReturnType<typeof useCreateOneTimeAuthLinkMutation>;
export type CreateOneTimeAuthLinkMutationResult = Apollo.MutationResult<CreateOneTimeAuthLinkMutation>;
export type CreateOneTimeAuthLinkMutationOptions = Apollo.BaseMutationOptions<CreateOneTimeAuthLinkMutation, CreateOneTimeAuthLinkMutationVariables>;
export const GetAppointmentsDocument = gql`
    query getAppointments($userIds: [Int!], $startDate: String!, $endDate: String!) {
  appointments(userIds: $userIds, startDate: $startDate, endDate: $endDate) {
    id
    date
    length
    contactMethod
    telehealthJoinUrl
    pmStatus
    attendees {
      id
      firstName
      lastName
      accountType
    }
    appointmentType {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables> & ({ variables: GetAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export function useGetAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsSuspenseQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetExternalOrganizationStatsDocument = gql`
    query getExternalOrganizationStats($providerLimit: Int, $providerOffset: Int) {
  externalOrganizations(
    limit: 10
    offset: 0
    providerLimit: $providerLimit
    providerOffset: $providerOffset
  ) {
    id
    name
    clientStats {
      timeframe
      referredClientCount
      activeClientCount
      totalClientCount
    }
    providers {
      id
      contact {
        fullName
      }
      clientStats {
        timeframe
        referredClientCount
        activeClientCount
        totalClientCount
      }
      lastReferralDate
    }
    totalProviderCount
    currentProviderId
  }
}
    `;

/**
 * __useGetExternalOrganizationStatsQuery__
 *
 * To run a query within a React component, call `useGetExternalOrganizationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalOrganizationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalOrganizationStatsQuery({
 *   variables: {
 *      providerLimit: // value for 'providerLimit'
 *      providerOffset: // value for 'providerOffset'
 *   },
 * });
 */
export function useGetExternalOrganizationStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>(GetExternalOrganizationStatsDocument, options);
      }
export function useGetExternalOrganizationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>(GetExternalOrganizationStatsDocument, options);
        }
export function useGetExternalOrganizationStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>(GetExternalOrganizationStatsDocument, options);
        }
export type GetExternalOrganizationStatsQueryHookResult = ReturnType<typeof useGetExternalOrganizationStatsQuery>;
export type GetExternalOrganizationStatsLazyQueryHookResult = ReturnType<typeof useGetExternalOrganizationStatsLazyQuery>;
export type GetExternalOrganizationStatsSuspenseQueryHookResult = ReturnType<typeof useGetExternalOrganizationStatsSuspenseQuery>;
export type GetExternalOrganizationStatsQueryResult = Apollo.QueryResult<GetExternalOrganizationStatsQuery, GetExternalOrganizationStatsQueryVariables>;
export const GetAuthenticatedProviderDocument = gql`
    query getAuthenticatedProvider {
  externalOrganizations(
    limit: 10
    offset: 0
    providerLimit: 100
    providerOffset: 0
  ) {
    id
    name
    currentProviderId
    totalProviderCount
    providers {
      id
      contact {
        firstName
        lastName
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetAuthenticatedProviderQuery__
 *
 * To run a query within a React component, call `useGetAuthenticatedProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticatedProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticatedProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthenticatedProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>(GetAuthenticatedProviderDocument, options);
      }
export function useGetAuthenticatedProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>(GetAuthenticatedProviderDocument, options);
        }
export function useGetAuthenticatedProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>(GetAuthenticatedProviderDocument, options);
        }
export type GetAuthenticatedProviderQueryHookResult = ReturnType<typeof useGetAuthenticatedProviderQuery>;
export type GetAuthenticatedProviderLazyQueryHookResult = ReturnType<typeof useGetAuthenticatedProviderLazyQuery>;
export type GetAuthenticatedProviderSuspenseQueryHookResult = ReturnType<typeof useGetAuthenticatedProviderSuspenseQuery>;
export type GetAuthenticatedProviderQueryResult = Apollo.QueryResult<GetAuthenticatedProviderQuery, GetAuthenticatedProviderQueryVariables>;